(function(){"use strict";try{if(typeof document!="undefined"){var a=document.createElement("style");a.appendChild(document.createTextNode('.stream-provider[data-v-2d54301a]{width:100%;height:100%;position:relative}.draggable-layout[data-v-065f0480]{user-select:none;touch-action:none;cursor:grab}.draggable-layout.dragging[data-v-065f0480]{cursor:grabbing;opacity:.9;z-index:1000}.drag-handle[data-v-065f0480]{position:absolute;z-index:1}.drag-handle.top[data-v-065f0480]{top:0;left:0;right:0;height:20px}.drag-handle.bottom[data-v-065f0480]{bottom:0;left:0;right:0;height:20px}.drag-handle.top-left[data-v-065f0480]{top:0;left:0;width:20px;height:20px}.drag-handle.top-right[data-v-065f0480]{top:0;right:0;width:20px;height:20px}.drag-handle.bottom-left[data-v-065f0480]{bottom:0;left:0;width:20px;height:20px}.drag-handle.bottom-right[data-v-065f0480]{bottom:0;right:0;width:20px;height:20px}.default-handle[data-v-065f0480]{width:100%;height:100%;background:#0000001a;transition:background-color .2s;display:flex;align-items:center;justify-content:center}.default-handle[data-v-065f0480]:hover{background:#0003}.default-handle[data-v-065f0480]:before{content:"⋮⋮";color:#ffffffb3;font-size:12px;letter-spacing:2px}.viewer-count[data-v-66d9289a]{display:flex;align-items:center;gap:6px;font-size:14px;padding:6px 10px;border-radius:5px;box-shadow:0 2px 8px #00000026}.viewer-count-text[data-v-66d9289a]{line-height:1;font-weight:500}.live-badge[data-v-9875bbcf]{display:flex;align-items:center;gap:6px;border-radius:5px;box-shadow:0 2px 8px #00000026}.live-dot[data-v-9875bbcf]{border-radius:50%;background-color:red;animation:flicker-9875bbcf 1s infinite}.live-dot.paused[data-v-9875bbcf]{background-color:#666;animation:none}.live-text[data-v-9875bbcf]{line-height:1;font-weight:500}@keyframes flicker-9875bbcf{0%,to{opacity:1}50%{opacity:.4}}.host-view[data-v-13b7080e]{position:relative;width:100%;min-height:400px;background-color:var(--4b7ef3a6);color:#fff;border-radius:var(--43046b86);overflow:hidden;--badge-font-size: var(--3f6b4b89);--badge-dot-size: var(--1ca62b31);--countdown-number-size: var(--18cd1151);--live-message-size: var(--f473771c)}.video-container[data-v-13b7080e]{width:100%;height:100%;border-radius:var(--43046b86);overflow:hidden;background-color:var(--4b7ef3a6)}.view-video[data-v-13b7080e]{width:100%;height:100%;border-radius:var(--43046b86);object-fit:var(--cd182584);background-color:var(--4b7ef3a6)}.view-placeholder[data-v-13b7080e]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background-color:var(--4b7ef3a6)}.permission-button-overlay[data-v-13b7080e]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:15}.permission-prompt-container[data-v-13b7080e]{display:flex;flex-direction:column;align-items:center;gap:24px;text-align:center;max-width:600px;padding:40px 32px;background:#0000004d;border-radius:16px;backdrop-filter:blur(10px)}.permission-prompt-text[data-v-13b7080e]{color:#fff;font-size:20px;margin:0;line-height:1.4;text-shadow:0 1px 3px rgba(0,0,0,.5)}@media (max-width: 768px){.permission-prompt-container[data-v-13b7080e]{max-width:90%;padding:32px 24px;gap:20px}.permission-prompt-text[data-v-13b7080e]{font-size:18px}}@media (max-width: 480px){.permission-prompt-container[data-v-13b7080e]{max-width:90%;padding:24px 16px;gap:16px}.permission-prompt-text[data-v-13b7080e]{font-size:16px}}.permission-button[data-v-13b7080e]{background:#1976d2;color:#fff;border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;cursor:pointer;display:flex;align-items:center;gap:8px;transition:all .2s ease;box-shadow:0 2px 8px #1976d24d}.permission-button[data-v-13b7080e]:hover{background:#1565c0;transform:translateY(-1px);box-shadow:0 4px 12px #1976d266}.permission-button svg[data-v-13b7080e]{color:#ea4335}.live-controls[data-v-13b7080e]{position:absolute;bottom:16px;left:50%;transform:translate(-50%);z-index:20}.status-overlay[data-v-13b7080e]{position:absolute;top:16px;right:16px;padding:4px;z-index:10;display:flex;gap:8px}.loading-overlay[data-v-13b7080e]{position:absolute;inset:0;background:#000000b3;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;z-index:20}.spinner[data-v-13b7080e]{width:20px;height:20px;border:2px solid rgba(255,255,255,.2);border-radius:50%;border-top-color:#fff;animation:spin-13b7080e 1s cubic-bezier(.5,0,.5,1) infinite;margin-bottom:10px}@keyframes spin-13b7080e{to{transform:rotate(360deg)}}.loading-overlay p[data-v-13b7080e]{font-size:14px;color:#fff}.screen-share-view[data-v-13b7080e]{width:100%;height:100%;object-fit:contain;background-color:var(--4b7ef3a6);position:absolute;top:0;left:0;z-index:10;border-radius:var(--43046b86);object-fit:var(--cd182584)}.view-video.hidden[data-v-13b7080e]{display:none}.floating-video-container[data-v-13b7080e]{width:180px;height:120px;background-color:var(--4b7ef3a6);border-radius:var(--43046b86);overflow:hidden;box-shadow:0 4px 8px #000c;border:2px solid rgba(255,255,255,.7);z-index:60}.floating-video[data-v-13b7080e]{width:100%;height:100%;object-fit:cover;border-radius:var(--43046b86)}.countdown-container[data-v-13b7080e],.message-container[data-v-13b7080e]{display:flex;flex-direction:column;align-items:center;justify-content:center}.countdown-number[data-v-13b7080e]{font-size:var(--countdown-number-size);font-weight:700;color:#fff;margin:0;animation:pulse-13b7080e .5s ease-out}.live-message[data-v-13b7080e]{font-size:var(--live-message-size);font-weight:700;color:#ea4335;margin:0;animation:fadeIn-13b7080e .5s ease-out}.connection-message[data-v-13b7080e]{font-size:16px;font-weight:600;color:#fff;margin:0;animation:fadeIn-13b7080e .5s ease-out;text-align:center}@keyframes pulse-13b7080e{0%{transform:scale(.8);opacity:0}50%{transform:scale(1.2);opacity:1}to{transform:scale(1);opacity:1}}@keyframes fadeIn-13b7080e{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}.connection-minutes-banner[data-v-13b7080e]{position:absolute;top:10px;left:10px;right:10px;background:#fffcf5;border:1px solid #b54708;padding:16px 24px;z-index:100;animation:slideDown-88a9dd25 .3s ease-out;box-shadow:0 4px 6px #0000001a;border-radius:12px}@keyframes slideDown-13b7080e{0%{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}.banner-content[data-v-13b7080e]{display:flex;justify-content:space-between;align-items:center;max-width:1200px;margin:0 auto;gap:24px}.banner-text[data-v-13b7080e]{flex:1;color:#b54708}.banner-title[data-v-13b7080e]{font-size:18px;font-weight:600;margin-bottom:4px}.banner-message[data-v-13b7080e]{font-size:14px;line-height:1.4;opacity:.95}.banner-actions[data-v-13b7080e]{display:flex;gap:12px;flex-shrink:0}.banner-button[data-v-13b7080e]{padding:10px 24px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;white-space:nowrap}.continue-button[data-v-13b7080e]{background:#b54708;color:#fff;backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.3)}.continue-button[data-v-13b7080e]:hover{background:#b54708;transform:translateY(-1px);box-shadow:0 4px 8px #0003}.continue-button[data-v-13b7080e]:active{transform:translateY(0)}.end-button[data-v-13b7080e]{background:#fff;color:#000;font-weight:600;border:1px solid #d0d5dd}.end-button[data-v-13b7080e]:hover{background:#f9fafb;transform:translateY(-1px);box-shadow:0 4px 8px #0003}.end-button[data-v-13b7080e]:active{background:#f3f4f6;transform:translateY(0)}@media (max-width: 1024px){.connection-minutes-banner[data-v-13b7080e]{top:8px;left:8px;right:8px;padding:12px 16px}.banner-content[data-v-13b7080e]{flex-direction:column;align-items:stretch;gap:16px}.banner-title[data-v-13b7080e]{font-size:16px;margin-bottom:6px}.banner-message[data-v-13b7080e]{font-size:13px;line-height:1.5}.banner-actions[data-v-13b7080e]{justify-content:stretch;gap:10px}.banner-button[data-v-13b7080e]{flex:1;padding:10px 16px;font-size:13px;min-height:44px}}@media (max-width: 768px){.connection-minutes-banner[data-v-13b7080e]{top:6px;left:6px;right:6px;padding:10px 12px;border-radius:8px}.banner-content[data-v-13b7080e]{gap:12px}.banner-title[data-v-13b7080e]{font-size:15px;margin-bottom:4px}.banner-message[data-v-13b7080e]{font-size:12px;line-height:1.4}.banner-actions[data-v-13b7080e]{flex-direction:column;gap:8px}.banner-button[data-v-13b7080e]{flex:none;width:100%;padding:12px 16px;font-size:14px;min-height:48px}}@media (max-width: 480px){.connection-minutes-banner[data-v-13b7080e]{top:4px;left:4px;right:4px;padding:8px 10px}.banner-title[data-v-13b7080e]{font-size:14px}.banner-message[data-v-13b7080e]{font-size:11px}.banner-button[data-v-13b7080e]{padding:10px 12px;font-size:13px}}.modal-overlay[data-v-13b7080e]{position:fixed;inset:0;background:#0009;display:flex;align-items:center;justify-content:center;z-index:1000;backdrop-filter:blur(4px)}.modal-content[data-v-13b7080e]{background:#fff;border-radius:12px;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;max-width:550px;width:90%;max-height:90vh;overflow:hidden;position:relative}.modal-header[data-v-13b7080e]{display:flex;align-items:center;justify-content:space-between;padding:20px 24px 0}.modal-title[data-v-13b7080e]{font-size:18px;font-weight:600;color:#111827;margin:0}.modal-close[data-v-13b7080e]{background:none;border:none;cursor:pointer;padding:4px;color:#6b7280;border-radius:6px;transition:all .2s;display:flex;align-items:center;justify-content:center}.modal-close[data-v-13b7080e]:hover{background:#f3f4f6;color:#374151}.modal-body[data-v-13b7080e]{padding:16px 24px 24px}.modal-message[data-v-13b7080e]{font-size:14px;line-height:1.5;color:#6b7280;margin:0}.modal-actions[data-v-13b7080e]{display:flex;gap:12px;padding:0 24px 24px;justify-content:flex-end}.modal-button[data-v-13b7080e]{padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;min-width:80px}.cancel-button[data-v-13b7080e]{background:#fff;color:#374151;border:1px solid #d1d5db}.cancel-button[data-v-13b7080e]:hover{background:#fff;border-color:#9ca3af;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.confirm-button[data-v-13b7080e]{background:#1d4981;color:#fff}.confirm-button[data-v-13b7080e]:hover{background:#1e3a72;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.confirm-button[data-v-13b7080e]:active{background:#162f5f;transform:translateY(0);box-shadow:0 2px 4px #1d498133}@media (max-width: 480px){.modal-content[data-v-13b7080e]{margin:16px;width:calc(100% - 32px)}.modal-header[data-v-13b7080e]{padding:16px 20px 0}.modal-title[data-v-13b7080e]{font-size:16px}.modal-body[data-v-13b7080e]{padding:12px 20px 20px}.modal-actions[data-v-13b7080e]{padding:0 20px 20px;flex-direction:column-reverse}.modal-button[data-v-13b7080e]{width:100%;padding:12px 16px}}.control-bar[data-v-a8560bb2]{display:flex;justify-content:center;align-items:center;gap:var(--6afd1946);padding:var(--066c35fc);background:var(--2a46e11f);border-radius:var(--3bf89cee);box-sizing:border-box;width:fit-content;z-index:80;--control-size: var(--291af05f);--icon-size: var(--3e7510a3);--icon-color: var(--6da17cdc);--text-color: var(--faac76b0);--active-color: var(--6da17cdc);font-size:var(--22bcfbfc);color:var(--faac76b0)}.control-bar.position-bottom[data-v-a8560bb2]{position:absolute;bottom:var(--54a8a166);left:50%;transform:translate(-50%)}.control-bar.position-top[data-v-a8560bb2]{position:absolute;top:var(--54a8a166);left:50%;transform:translate(-50%)}.control-bar.position-left[data-v-a8560bb2]{position:absolute;left:var(--54a8a166);top:50%;transform:translateY(-50%)}.control-bar.position-right[data-v-a8560bb2]{position:absolute;right:var(--54a8a166);top:50%;transform:translateY(-50%)}.control-bar.vertical[data-v-a8560bb2]{flex-direction:column;width:fit-content}.control-bar.vertical .controls-group[data-v-a8560bb2]{flex-direction:column}.control-bar.vertical .controls-end[data-v-a8560bb2]{flex-direction:column;margin-top:var(--6afd1946)}.controls-group[data-v-a8560bb2],.controls-end[data-v-a8560bb2]{display:flex;align-items:center;gap:var(--6afd1946)}.control-label[data-v-a8560bb2]{font-size:.75em;font-weight:500;text-align:center;white-space:nowrap;margin-top:4px}.flip-icon[data-v-a8560bb2],.end-icon[data-v-a8560bb2]{display:flex;align-items:center;justify-content:center;width:var(--3e72cac3);height:var(--3e72cac3)}.settings-container[data-v-a8560bb2]{position:relative}.settings-dropdown[data-v-a8560bb2]{position:absolute;background:var(--64500d76);border-radius:var(--3611d5a9);box-shadow:0 4px 24px #0000004d;z-index:1000;width:var(--a30f1170);max-width:90vw;overflow:hidden;padding:6px;border:1px solid rgba(255,255,255,.1);color:var(--6da17cdc)}.dropdown-content[data-v-a8560bb2]{display:flex;flex-direction:column;gap:var(--39f80043)}.device-select[data-v-a8560bb2]{display:flex;flex-direction:column}.select-wrapper[data-v-a8560bb2]{position:relative;display:flex;align-items:center;background:var(--21e44974);border-radius:var(--3611d5a9);padding:var(--664f7beb) var(--48065b4b);border:1px solid rgba(255,255,255,.3)}.device-icon[data-v-a8560bb2]{width:var(--02c67c36);height:var(--02c67c36);margin-right:8px;opacity:.7;color:var(--6da17cdc)}.arrow-icon[data-v-a8560bb2]{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:var(--02c67c36);height:var(--02c67c36);color:var(--6da17cdc);opacity:.7;pointer-events:none}.device-select select[data-v-a8560bb2]{background:transparent;border:none;color:var(--faac76b0);font-size:var(--7b1b86ce);appearance:none;width:100%;padding:var(--1e6e4708) var(--3e72cac3) var(--1e6e4708) 0;background-image:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;height:100%;flex:1}.device-select select[data-v-a8560bb2]:focus{outline:none}.device-select select option[data-v-a8560bb2]{background:var(--306cc12f);color:var(--faac76b0);padding:var(--1e6e4708);font-size:var(--7b1b86ce)}.control-bar.position-bottom.screen-share-active[data-v-a8560bb2]{z-index:30}.control-bar.position-left .settings-dropdown[data-v-a8560bb2]{bottom:auto;top:50%;left:100%;transform:translateY(-50%);margin-left:12px}.control-bar.position-right .settings-dropdown[data-v-a8560bb2]{bottom:auto;top:50%;right:100%;transform:translateY(-50%);margin-right:12px}.control-bar.position-top .settings-dropdown[data-v-a8560bb2]{bottom:auto;top:100%;left:50%;transform:translate(-50%);margin-top:12px}.control-bar.position-bottom .settings-dropdown[data-v-a8560bb2]{top:auto;bottom:100%;left:50%;transform:translate(-50%);margin-bottom:12px}@media (max-width: 480px){.settings-dropdown[data-v-a8560bb2]{position:absolute;left:50%;right:auto;bottom:auto;transform:translate(-50%,-50%)}.control-bar.position-right .settings-dropdown[data-v-a8560bb2]{transform:translateY(-50%) translate(-110%)}.control-bar .settings-dropdown[data-v-a8560bb2]{position:fixed}.dropdown-content[data-v-a8560bb2]{max-height:80vh;overflow-y:auto}}.control-bar.no-background[data-v-a8560bb2]{padding:0;background:transparent;backdrop-filter:none;border-radius:0;box-shadow:none}.control-bar.no-background .controls-group[data-v-a8560bb2]{gap:var(--6afd1946)}.control-bar.position-right.no-background[data-v-a8560bb2]{right:12px}.control-bar.position-left.no-background[data-v-a8560bb2]{left:12px}.control-bar.position-bottom.no-background[data-v-a8560bb2]{bottom:12px}.control-bar.position-top.no-background[data-v-a8560bb2]{top:12px}.control-bar.no-background .settings-dropdown[data-v-a8560bb2]{background:var(--7a4a6546);border-radius:12px;box-shadow:0 4px 24px #00000080;padding:6px}.controls-group[data-v-a8560bb2]{display:flex;align-items:center;gap:var(--6afd1946);transition:all .2s ease-out}.controls-group[data-v-a8560bb2]{display:flex;align-items:center;gap:var(--6afd1946);transition:all .3s ease-in-out}.control-item[data-v-a8560bb2]{flex:0 0 auto;width:var(--control-size);height:var(--control-size);display:flex;align-items:center;justify-content:center;box-sizing:border-box;position:relative}.permission-indicator[data-v-a8560bb2]{position:absolute;top:-5px;right:-5px;background:#fa7b16;color:#fff;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;z-index:10}.permission-denied[data-v-a8560bb2]{background-color:#ea4335;border:1px solid rgb(234,67,53);border-radius:10px}.permission-denied[data-v-a8560bb2]:hover{opacity:1;transform:scale(1.05)}.controls-animation-enter-active[data-v-a8560bb2],.controls-animation-leave-active[data-v-a8560bb2]{transition:all .3s ease-in-out}.controls-animation-enter-from[data-v-a8560bb2],.controls-animation-leave-to[data-v-a8560bb2]{opacity:0;transform:scale(.8);width:0;height:0;margin-right:calc(-1 * var(--c3b90532) + "px");margin-left:calc(-1 * var(--c3b90532) + "px")}.controls-animation-move[data-v-a8560bb2]{transition:all .3s ease-in-out}.toggle-button[data-v-a8560bb2]{transition:transform .3s ease-in-out}.toggle-button[data-v-a8560bb2]:hover{transform:scale(1.1)}.mic-meter-wrapper[data-v-a8560bb2]{width:100%;padding:6px 0}.mic-disabled-message[data-v-a8560bb2]{width:100%;text-align:center;padding:4px 0 4px 6px;font-size:12px;opacity:.7;color:var(--faac76b0)}.control-bar.no-background .select-wrapper select[data-v-a8560bb2]{filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}.stream-chat[data-v-fb9e4dc1]{display:flex;flex-direction:column;height:100%;background:#fefeff;color:#333;overflow:hidden;position:relative}.file-size-error-notification[data-v-fb9e4dc1]{padding:16px;animation:slideInFromBottom-fb9e4dc1 .3s ease-out}.error-content[data-v-fb9e4dc1]{background:gold;color:#8b4513;padding:12px 16px;border-radius:8px;display:flex;align-items:center;justify-content:space-between;box-shadow:0 4px 12px #00000026;border:1px solid #e6c200}.error-text[data-v-fb9e4dc1]{font-size:14px;font-weight:500;flex:1;margin-right:12px}.error-dismiss-button[data-v-fb9e4dc1]{background:none;border:none;color:#8b4513;font-size:18px;font-weight:700;cursor:pointer;padding:0;width:24px;height:24px;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background-color .2s}.error-dismiss-button[data-v-fb9e4dc1]:hover{background-color:#8b45131a}@keyframes slideInFromBottom-fb9e4dc1{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}.stream-chat.inside-player[data-v-fb9e4dc1]{background:transparent;color:#fff}.message-list[data-v-fb9e4dc1]{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px;scrollbar-width:none;-ms-overflow-style:none}.message-list[data-v-fb9e4dc1]::-webkit-scrollbar{display:none}.message-spacer[data-v-fb9e4dc1]{flex:1;min-height:0}.empty-state[data-v-fb9e4dc1]{flex:1;display:flex;align-items:center;justify-content:center;padding:40px 20px;text-align:center}.empty-state-content[data-v-fb9e4dc1]{max-width:300px;animation:fadeIn-fb9e4dc1 .5s ease-out}.empty-state-icon[data-v-fb9e4dc1]{margin-bottom:16px;display:flex;justify-content:center}.icon-circle-outer[data-v-fb9e4dc1]{width:56px;height:56px;border-radius:50%;background-color:#f0f4ff;display:flex;align-items:center;justify-content:center}.icon-circle-inner[data-v-fb9e4dc1]{width:40px;height:40px;border-radius:50%;background-color:#e0e7ff;display:flex;align-items:center;justify-content:center;color:#2563eb}.empty-state-heading[data-v-fb9e4dc1]{font-size:18px;font-weight:600;color:#333;margin:0 0 8px;line-height:1.3}.empty-state-message[data-v-fb9e4dc1]{font-size:14px;color:#666;margin:0;line-height:1.4}.stream-chat.inside-player .empty-state-heading[data-v-fb9e4dc1]{color:#fff;text-shadow:0 1px 2px rgba(0,0,0,.5)}.stream-chat.inside-player .empty-state-message[data-v-fb9e4dc1]{color:#fffc;text-shadow:0 1px 2px rgba(0,0,0,.5)}.stream-chat.inside-player .icon-circle-outer[data-v-fb9e4dc1]{background-color:#ffffff0d;backdrop-filter:blur(8px)}.stream-chat.inside-player .icon-circle-inner[data-v-fb9e4dc1]{background-color:#ffffff1a;color:#fffc}.message-wrapper[data-v-fb9e4dc1]{display:flex;gap:8px;align-items:flex-start;justify-content:flex-start}.message-wrapper.own-message[data-v-fb9e4dc1]{flex-direction:row;justify-content:flex-start}.message-avatar[data-v-fb9e4dc1]{flex-shrink:0}.message-content[data-v-fb9e4dc1]{display:flex;flex-direction:column;gap:4px;max-width:95%;width:fit-content;align-items:flex-start}.own-message .message-content[data-v-fb9e4dc1]{align-items:flex-start}.message-sender[data-v-fb9e4dc1]{font-size:12px;font-weight:600;color:#666;display:flex;align-items:center;gap:6px}.stream-chat.inside-player .message-sender[data-v-fb9e4dc1]{color:#fff}.host-tag[data-v-fb9e4dc1]{background:#5773ff;color:#fff;font-size:10px;font-weight:600;padding:2px 6px;border-radius:8px;text-transform:uppercase;letter-spacing:.5px}.stream-chat.inside-player .host-tag[data-v-fb9e4dc1]{background:#5773ffe6;backdrop-filter:blur(4px)}.message-bubble[data-v-fb9e4dc1]{background:#f8f9fa;padding:8px 12px;overflow-wrap:break-word;word-break:normal;width:fit-content;border:1px solid #e9ecef;border-radius:16px;box-shadow:0 1px 2px #0000000d}.own-message .message-bubble[data-v-fb9e4dc1]{background:#e3f2fd;border-color:#bbdefb}.stream-chat.inside-player .message-bubble[data-v-fb9e4dc1]{background:#ffffff26;padding:8px 12px;border:2px solid rgba(255,255,255,.2);width:fit-content;min-width:60px}.stream-chat.inside-player .own-message .message-bubble[data-v-fb9e4dc1]{background:#e3f2fd33;border-color:#ffffff4d}.bubble-rounded[data-v-fb9e4dc1]{border-radius:16px}.bubble-square[data-v-fb9e4dc1]{border-radius:4px}.bubble-minimal[data-v-fb9e4dc1]{border-radius:0;background:transparent;padding:4px 0}.message-text[data-v-fb9e4dc1]{margin:0;line-height:1.5;font-size:16px;color:#333;text-align:left}.message-text.preserve-whitespace[data-v-fb9e4dc1]{white-space:pre-wrap}.message-attachment-container[data-v-fb9e4dc1]{margin:8px 0}.own-message .message-text[data-v-fb9e4dc1]{text-align:left}.stream-chat.inside-player .message-text[data-v-fb9e4dc1]{color:#fff;text-align:left;text-shadow:none}.stream-chat.inside-player .own-message .message-text[data-v-fb9e4dc1]{text-align:left}.message-timestamp[data-v-fb9e4dc1]{font-size:11px;opacity:.5;color:#666}.message-timestamp.inline[data-v-fb9e4dc1]{font-size:11px;opacity:.6;color:#999;font-weight:400}.stream-chat.inside-player .message-timestamp[data-v-fb9e4dc1]{color:#fff}.stream-chat.inside-player .message-timestamp.inline[data-v-fb9e4dc1]{color:#ffffffb3}.message-attachment-container[data-v-fb9e4dc1]{width:100%}.message-attachment[data-v-fb9e4dc1]{border-radius:8px;overflow:hidden}.image-attachment[data-v-fb9e4dc1]{cursor:pointer;max-width:300px}.attachment-preview-image[data-v-fb9e4dc1]{width:100%;height:auto;max-height:300px;object-fit:cover;display:block;border-radius:8px}.video-attachment[data-v-fb9e4dc1]{max-width:400px}.attachment-preview-video[data-v-fb9e4dc1]{width:100%;height:auto;max-height:300px;border-radius:8px;background:#000}.document-attachment[data-v-fb9e4dc1]{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px;background:#f8f9fa;border:1px solid #e5e5e5;border-radius:8px}.stream-chat.inside-player .document-attachment[data-v-fb9e4dc1]{background:#ffffff1a;border-color:#fff3}.attachment-info[data-v-fb9e4dc1]{display:flex;align-items:center;gap:8px;flex:1;min-width:0}.attachment-details[data-v-fb9e4dc1]{display:flex;flex-direction:column;min-width:0;text-align:left}.own-message .attachment-details[data-v-fb9e4dc1]{text-align:left}.attachment-name[data-v-fb9e4dc1]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.stream-chat.inside-player .attachment-name[data-v-fb9e4dc1]{color:#fff}.attachment-size[data-v-fb9e4dc1]{font-size:12px;color:#6c757d;margin-top:2px}.stream-chat.inside-player .attachment-size[data-v-fb9e4dc1]{color:#ffffffb3}.stream-chat.inside-player .attachment-details[data-v-fb9e4dc1],.stream-chat.inside-player .own-message .attachment-details[data-v-fb9e4dc1]{text-align:left}.download-button[data-v-fb9e4dc1]{flex-shrink:0;width:36px;height:36px;background:#fff;border:1px solid #e5e5e5;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.download-button[data-v-fb9e4dc1]:hover{background:#f8f9fa;color:#495057;transform:scale(1.05)}.stream-chat.inside-player .download-button[data-v-fb9e4dc1]{background:#ffffff1a;border-color:#ffffff4d;color:#fff}.stream-chat.inside-player .download-button[data-v-fb9e4dc1]:hover{background:#fff3}.input-container[data-v-fb9e4dc1]{display:flex;flex-direction:column;gap:8px;padding:12px;background:#fff;border:1px solid #e5e5e5;border-radius:12px;margin:16px}.stream-chat.inside-player .input-container[data-v-fb9e4dc1]{flex-direction:row;gap:8px;padding:12px;background:transparent;border:none;border-radius:0;margin:0;border-top:1px solid rgba(255,255,255,.1)}.input-wrapper[data-v-fb9e4dc1]{flex:1;display:flex;position:relative}.buttons-row[data-v-fb9e4dc1]{display:flex;justify-content:space-between;align-items:center}.icons-group[data-v-fb9e4dc1]{display:flex;align-items:center}.icons-group .attachment-button[data-v-fb9e4dc1],.icons-group .emoji-button[data-v-fb9e4dc1]{width:36px;height:36px}.message-input[data-v-fb9e4dc1]{flex:1;background:#f0f0f0;border:1px solid #d1d5db;transition:border-color .2s,box-shadow .2s;border:none;padding:0;color:#333;font-size:14px;outline:none;transition:all .2s}.message-input.standalone[data-v-fb9e4dc1]{width:100%;border:none;border-radius:12px;padding:12px 16px;min-height:44px;max-height:120px;box-sizing:border-box;resize:none;font-family:inherit;line-height:1.4;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.2) transparent}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar{width:4px}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar-track{background:transparent}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar-thumb{background:#0003;border-radius:2px}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar-thumb:hover{background:#0000004d}.stream-chat.inside-player .message-input[data-v-fb9e4dc1]{background:#ffffff1a;border:1px solid rgba(255,255,255);border-radius:8px;padding:8px 12px;color:#fff}.message-input[data-v-fb9e4dc1]:focus{outline:none}.message-input.standalone[data-v-fb9e4dc1]:focus{background:#f0f0f0}.stream-chat.inside-player .message-input[data-v-fb9e4dc1]:focus{background:#ffffff26;border-color:#ffffff4d}.message-input[data-v-fb9e4dc1]::placeholder{color:#999}.stream-chat.inside-player .message-input[data-v-fb9e4dc1]::placeholder{color:#fff}.message-input[data-v-fb9e4dc1]:disabled{opacity:.5;cursor:not-allowed}.attachment-button[data-v-fb9e4dc1],.emoji-button[data-v-fb9e4dc1],.send-button[data-v-fb9e4dc1]{background:transparent;border:none;color:#6c757d;cursor:pointer;padding:8px;border-radius:8px;transition:all .2s;display:flex;align-items:center;justify-content:center}.attachment-button[data-v-fb9e4dc1]:hover,.emoji-button[data-v-fb9e4dc1]:hover{background:#0000000d;color:#495057}.stream-chat.inside-player .attachment-button[data-v-fb9e4dc1],.stream-chat.inside-player .emoji-button[data-v-fb9e4dc1],.stream-chat.inside-player .send-button[data-v-fb9e4dc1]{color:#fff}.stream-chat.inside-player .attachment-button[data-v-fb9e4dc1]:hover,.stream-chat.inside-player .emoji-button[data-v-fb9e4dc1]:hover,.stream-chat.inside-player .send-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#ffffff1a}.attachment-button[data-v-fb9e4dc1]:disabled,.emoji-button[data-v-fb9e4dc1]:disabled,.send-button[data-v-fb9e4dc1]:disabled{opacity:.5;cursor:not-allowed}.send-button[data-v-fb9e4dc1]{background:#5773ff;color:#fff;width:36px;height:36px;border-radius:12px}.send-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#4361ee}.stream-chat.inside-player .send-button[data-v-fb9e4dc1]{background:#0084ff;color:#fff;width:36px;height:36px}.stream-chat.inside-player .send-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#0073e6}.stream-chat.inside-player .input-wrapper .attachment-button[data-v-fb9e4dc1]{position:static;margin-right:8px}.stream-chat.inside-player[data-v-fb9e4dc1]{position:absolute;bottom:0;left:0;right:0;height:40%;max-height:400px;z-index:50}.stream-chat.inside-player .message-list[data-v-fb9e4dc1]{background:transparent;padding:12px 16px;max-height:calc(100% - 60px);mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%);-webkit-mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%)}.stream-chat.inside-player .message-wrapper.own-message[data-v-fb9e4dc1]{flex-direction:row}.stream-chat.inside-player .own-message .message-content[data-v-fb9e4dc1]{align-items:flex-start}.stream-chat.inside-player .message-content[data-v-fb9e4dc1]{width:auto}.file-preview[data-v-fb9e4dc1]{display:flex;align-items:center;gap:12px;background:#f0f2f5;border-radius:8px;width:100%;padding:12px;box-sizing:border-box}.file-icon[data-v-fb9e4dc1]{flex-shrink:0;width:40px;height:40px;background:#e9ecef;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#6c757d}.file-preview-thumbnail[data-v-fb9e4dc1]{flex-shrink:0;width:40px;height:40px;border-radius:8px;overflow:hidden}.file-preview-thumbnail img[data-v-fb9e4dc1]{width:100%;height:100%;object-fit:cover}.file-info[data-v-fb9e4dc1]{flex:1;min-width:0}.file-name[data-v-fb9e4dc1]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-size[data-v-fb9e4dc1]{font-size:12px;color:#6c757d;margin-top:2px}.file-remove-button[data-v-fb9e4dc1]{flex-shrink:0;width:32px;height:32px;background:transparent;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.file-remove-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#0000000d;color:#dc3545}.file-remove-button[data-v-fb9e4dc1]:disabled{opacity:.5;cursor:not-allowed}.progress-ring[data-v-fb9e4dc1]{animation:rotate-fb9e4dc1 2s linear infinite}.progress-ring-circle[data-v-fb9e4dc1]{transition:stroke-dasharray .3s ease}@keyframes rotate-fb9e4dc1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.loading-more-indicator[data-v-fb9e4dc1]{display:flex;align-items:center;justify-content:center;gap:8px;padding:16px;margin-bottom:8px;animation:fadeInDown-fb9e4dc1 .3s ease-out}.loading-spinner[data-v-fb9e4dc1]{width:16px;height:16px;border:2px solid #e5e5e5;border-top:2px solid #5773ff;border-radius:50%;animation:spin-fb9e4dc1 1s linear infinite}.loading-text[data-v-fb9e4dc1]{font-size:12px;color:#666;font-weight:500}.stream-chat.inside-player .loading-text[data-v-fb9e4dc1]{color:#fffc}.stream-chat.inside-player .loading-spinner[data-v-fb9e4dc1]{border-color:#ffffff4d;border-top-color:#fff}.no-more-indicator[data-v-fb9e4dc1]{display:flex;align-items:center;justify-content:center;padding:12px;margin-bottom:8px;animation:fadeInDown-fb9e4dc1 .3s ease-out}.no-more-text[data-v-fb9e4dc1]{font-size:11px;color:#999;text-align:center}.stream-chat.inside-player .no-more-text[data-v-fb9e4dc1]{color:#fff9}.initial-loading-bottom[data-v-fb9e4dc1]{padding:16px;animation:slideInFromBottom-fb9e4dc1 .4s ease-out;background:#00000003}.message-skeleton[data-v-fb9e4dc1]{display:flex;gap:8px;align-items:flex-start;margin-bottom:16px;animation:pulse-fb9e4dc1 1.5s ease-in-out infinite}.skeleton-avatar[data-v-fb9e4dc1]{width:32px;height:32px;border-radius:50%;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-fb9e4dc1 1.5s infinite}.skeleton-content[data-v-fb9e4dc1]{flex:1;display:flex;flex-direction:column;gap:6px;max-width:70%}.skeleton-name[data-v-fb9e4dc1]{width:80px;height:12px;border-radius:6px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-fb9e4dc1 1.5s infinite}.skeleton-text[data-v-fb9e4dc1]{height:14px;border-radius:7px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-fb9e4dc1 1.5s infinite}.skeleton-text[data-v-fb9e4dc1]:not(.short){width:100%}.skeleton-text.short[data-v-fb9e4dc1]{width:60%}.stream-chat.inside-player .initial-loading-bottom[data-v-fb9e4dc1]{background:#ffffff0d;padding:8px 16px}.stream-chat.inside-player .message-skeleton[data-v-fb9e4dc1]{margin-bottom:8px}.stream-chat.inside-player .skeleton-avatar[data-v-fb9e4dc1],.stream-chat.inside-player .skeleton-name[data-v-fb9e4dc1],.stream-chat.inside-player .skeleton-text[data-v-fb9e4dc1]{background:linear-gradient(90deg,#ffffff1a 25%,#fff3,#ffffff1a 75%);background-size:200% 100%}.new-message-notification[data-v-fb9e4dc1]{position:absolute;bottom:180px;left:50%;transform:translate(-50%);background:#5773ff;color:#fff;border:none;border-radius:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;padding:6px 10px;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10;min-width:120px}.new-message-notification[data-v-fb9e4dc1]:hover{transform:translate(-50%) translateY(-2px);box-shadow:0 6px 20px #5773ff66;background:#4361ee}.new-message-notification[data-v-fb9e4dc1]:active{transform:translate(-50%) translateY(0)}.new-message-text[data-v-fb9e4dc1]{font-size:13px;font-weight:500}.stream-chat.inside-player .new-message-notification[data-v-fb9e4dc1]{background:#000c;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0006;bottom:80px}.stream-chat.inside-player .new-message-notification[data-v-fb9e4dc1]:hover{background:#000000e6;box-shadow:0 6px 20px #00000080}.scroll-to-bottom-button[data-v-fb9e4dc1]{position:absolute;bottom:140px;right:16px;width:48px;height:48px;background:#5773ff;color:#fff;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10}.scroll-to-bottom-button[data-v-fb9e4dc1]:hover{transform:translateY(-2px);box-shadow:0 6px 20px #5773ff66}.scroll-to-bottom-button[data-v-fb9e4dc1]:active{transform:translateY(0)}.scroll-to-bottom-button.inside-player[data-v-fb9e4dc1]{background:#000000b3;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0000004d}.scroll-to-bottom-button.inside-player[data-v-fb9e4dc1]:hover{background:#000c;box-shadow:0 6px 20px #0006}.scroll-button-enter-active[data-v-fb9e4dc1],.scroll-button-leave-active[data-v-fb9e4dc1]{transition:all .3s cubic-bezier(.4,0,.2,1)}.scroll-button-enter-from[data-v-fb9e4dc1],.scroll-button-leave-to[data-v-fb9e4dc1]{opacity:0;transform:translateY(20px) scale(.8)}.new-message-notification-enter-active[data-v-fb9e4dc1],.new-message-notification-leave-active[data-v-fb9e4dc1]{transition:all .3s cubic-bezier(.4,0,.2,1)}.new-message-notification-enter-from[data-v-fb9e4dc1],.new-message-notification-leave-to[data-v-fb9e4dc1]{opacity:0;transform:translate(-50%) translateY(20px) scale(.9)}@keyframes spin-fb9e4dc1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes shimmer-fb9e4dc1{0%{background-position:-200% 0}to{background-position:200% 0}}@keyframes fadeIn-fb9e4dc1{0%{opacity:0}to{opacity:1}}@keyframes fadeInDown-fb9e4dc1{0%{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}@keyframes pulse-fb9e4dc1{0%,to{opacity:1}50%{opacity:.7}}@keyframes bounce-fb9e4dc1{0%,20%,53%,80%,to{transform:translateZ(0)}40%,43%{transform:translate3d(0,-8px,0)}70%{transform:translate3d(0,-4px,0)}90%{transform:translate3d(0,-2px,0)}}@media (max-width: 768px){.message-list[data-v-fb9e4dc1]{padding:12px}.message-content[data-v-fb9e4dc1]{max-width:85%}.input-container[data-v-fb9e4dc1]{padding:8px}.stream-chat.inside-player[data-v-fb9e4dc1]{height:50%;max-height:300px}.image-attachment[data-v-fb9e4dc1],.video-attachment[data-v-fb9e4dc1]{max-width:100%}.attachment-preview-image[data-v-fb9e4dc1],.attachment-preview-video[data-v-fb9e4dc1]{max-height:200px}.document-attachment[data-v-fb9e4dc1]{padding:10px}.attachment-name[data-v-fb9e4dc1]{font-size:13px}.scroll-to-bottom-button[data-v-fb9e4dc1]{width:44px;height:44px;bottom:70px;right:12px}.loading-more-indicator[data-v-fb9e4dc1],.initial-loading[data-v-fb9e4dc1]{padding:12px}}.attendee-player[data-v-0270311a]{position:relative;width:100%;height:100%;background-color:var(--299d9c90)}.stream-video[data-v-0270311a]{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:var(--11b25813);cursor:pointer;z-index:1}.stream-video.hidden[data-v-0270311a]{display:none}.screen-share-video[data-v-0270311a]{position:absolute;inset:0;width:100%;height:100%;object-fit:var(--11b25813);background-color:var(--299d9c90);z-index:2}.floating-video-container[data-v-0270311a]{width:200px;height:150px;background-color:var(--299d9c90);border-radius:8px;overflow:hidden;box-shadow:0 4px 12px #0006;border:2px solid rgba(255,255,255,.7);z-index:60}@media (max-width: 768px){.floating-video-container[data-v-0270311a]{width:120px;height:90px}}.floating-video[data-v-0270311a]{width:100%;height:100%;object-fit:cover}.loading-overlay[data-v-0270311a],.no-stream-overlay[data-v-0270311a]{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#000000b3;gap:16px;z-index:20}.host-avatar-placeholder[data-v-0270311a]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#1a1a1afa,#282828f2)}.spinner[data-v-0270311a]{width:20px;height:20px;border:2px solid rgba(255,255,255,.2);border-radius:50%;border-top-color:#fff;animation:spin-0270311a 1s cubic-bezier(.5,0,.5,1) infinite;margin-bottom:10px}@keyframes spin-0270311a{to{transform:rotate(360deg)}}.loading-text[data-v-0270311a]{font-size:16px;font-weight:600;color:#fff;text-align:center;line-height:1.5;padding:0 20px;max-width:400px;text-shadow:0 2px 4px rgba(0,0,0,.3);animation:fadeIn-0270311a .5s ease-out;margin:0}@keyframes fadeIn-0270311a{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}.stream-info-overlay[data-v-0270311a]{position:absolute;inset:0;pointer-events:none;z-index:100}.status-bar[data-v-0270311a]{position:absolute;top:16px;right:16px;display:flex;gap:8px;pointer-events:auto}.play-pause-button[data-v-0270311a]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:60px;height:60px;background:none;border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;pointer-events:auto;transition:all .2s ease;opacity:1}.play-pause-button[data-v-0270311a]:hover{transform:translate(-50%,-50%) scale(1.1)}.play-pause-button[data-v-0270311a]:active{transform:translate(-50%,-50%) scale(.95);transition:all .1s ease}.play-pause-button.playing[data-v-0270311a]{opacity:0;pointer-events:none}.video-container:hover .play-pause-button.playing[data-v-0270311a],.video-container[data-v-0270311a]:hover .attendee-control-bar{opacity:1;pointer-events:auto}@media (max-width: 768px){.status-bar[data-v-0270311a]{top:8px;right:8px}.play-pause-button[data-v-0270311a]{width:48px;height:48px}.loading-text[data-v-0270311a]{padding:0 16px}}@media (hover: none){.play-pause-button.playing[data-v-0270311a]{opacity:0;transition:opacity .3s ease 1s}.video-container:active .play-pause-button.playing[data-v-0270311a]{opacity:1;transition:opacity .1s ease}[data-v-0270311a] .attendee-control-bar{opacity:1;pointer-events:auto}}.attendee-control-bar[data-v-c373cbf1]{position:absolute;bottom:0;left:0;right:0;background:var(--856235fc);backdrop-filter:var(--a8dd41ca);opacity:1;transition:opacity .3s ease;pointer-events:none;z-index:200;transform:translateY(0)}.controls-container[data-v-c373cbf1]{display:flex;justify-content:space-between;align-items:center}.controls-left[data-v-c373cbf1],.controls-right[data-v-c373cbf1]{display:flex;align-items:center;gap:var(--30dc32a8)}.control-button[data-v-c373cbf1]{width:var(--45bbe64e);height:var(--45bbe64e);border-radius:4px;background:var(--28fbfe66);border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .2s ease;backdrop-filter:blur(10px);margin:4px 2px}.control-button[data-v-c373cbf1]:hover{background:var(--011747ec);transform:var(--6e512c7d);border-radius:var(--f48da108);border:var(--e5d06a3c)}.control-button[data-v-c373cbf1]:active{background:var(--bf7583c8);transform:var(--15dd69b5);border-radius:var(--1611be08);border:var(--ff6e2d3c)}.volume-control[data-v-c373cbf1]{display:flex;align-items:center;gap:var(--30dc32a8)}.volume-slider[data-v-c373cbf1]{width:0;height:var(--1cd2c70c);-webkit-appearance:none;appearance:none;background:var(--1ca8b846);outline:none;border-radius:var(--32c3ad37);cursor:pointer;transition:width .3s ease,opacity .3s ease;opacity:0;margin:0}.volume-control:hover .volume-slider[data-v-c373cbf1]{width:60px;opacity:1}.volume-slider[data-v-c373cbf1]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:var(--7711a4dd);height:var(--0a4cf084);background:var(--13ee4626);border-radius:var(--d6215ec8);cursor:pointer;transition:transform .1s ease;box-shadow:var(--26fdc13a)}.volume-slider[data-v-c373cbf1]::-webkit-slider-thumb:hover{transform:scale(1.2)}.volume-slider[data-v-c373cbf1]::-moz-range-thumb{width:var(--7711a4dd);height:var(--0a4cf084);background:var(--13ee4626);border-radius:var(--d6215ec8);cursor:pointer;border:none;transition:transform .1s ease;box-shadow:var(--26fdc13a)}.volume-slider[data-v-c373cbf1]::-moz-range-thumb:hover{transform:scale(1.2)}@media (max-width: 768px){.attendee-control-bar[data-v-c373cbf1]{opacity:1;pointer-events:auto}.volume-slider[data-v-c373cbf1]{width:0}.volume-control:hover .volume-slider[data-v-c373cbf1]{width:50px}}.live-indicator[data-v-c373cbf1]{display:flex;align-items:center;margin-left:8px;pointer-events:none}@media (hover: none){.attendee-control-bar[data-v-c373cbf1]{opacity:1;pointer-events:auto}.volume-slider[data-v-c373cbf1]{width:50px;opacity:1}}')),document.head.appendChild(a)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var ya = Object.defineProperty, ga = Object.defineProperties;
var Sa = Object.getOwnPropertyDescriptors;
var Rt = Object.getOwnPropertySymbols;
var ba = Object.prototype.hasOwnProperty, ka = Object.prototype.propertyIsEnumerable;
var Lt = (W, y, h) => y in W ? ya(W, y, { enumerable: !0, configurable: !0, writable: !0, value: h }) : W[y] = h, a = (W, y) => {
  for (var h in y || (y = {}))
    ba.call(y, h) && Lt(W, h, y[h]);
  if (Rt)
    for (var h of Rt(y))
      ka.call(y, h) && Lt(W, h, y[h]);
  return W;
}, ht = (W, y) => ga(W, Sa(y));
var I = (W, y, h) => new Promise((e, k) => {
  var D = (E) => {
    try {
      g(h.next(E));
    } catch (A) {
      k(A);
    }
  }, m = (E) => {
    try {
      g(h.throw(E));
    } catch (A) {
      k(A);
    }
  }, g = (E) => E.done ? e(E.value) : Promise.resolve(E.value).then(D, m);
  g((h = h.apply(W, y)).next());
});
import { ref as w, watchEffect as rt, computed as n, defineComponent as Ye, provide as lt, onMounted as ut, createElementBlock as p, openBlock as l, renderSlot as Ze, onUnmounted as Et, withModifiers as qe, normalizeStyle as f, normalizeClass as be, createCommentVNode as z, createElementVNode as o, inject as it, createVNode as Y, toDisplayString as ie, unref as r, useCssVars as gt, watch as Be, withDirectives as ct, createBlock as ye, vShow as yt, withCtx as Pe, createTextVNode as _t, TransitionGroup as wa, Fragment as De, renderList as st, nextTick as kt, Transition as At, withKeys as $t, vModelText as Ft, shallowRef as wt } from "vue";
import { u as dt, a as zt, b as Yt, C as ue, c as It, d as Gt, e as Xt, f as Ca, g as xa, h as Ta, O as _a, i as Ea, j as za, k as Ia, l as Ma, A as Mt, P as Kt, m as at, n as Pa, o as Ba, p as Ra, q as La, r as Aa, s as $a, t as Fa, v as Na, N as Da } from "./useChatPagination-x-ZuSkpz.js";
import { C as Nt, o as ja, R as Qe, P as Dt, T as pt } from "./live-vendor-DtCPNuLC.js";
import { a as Oa, A as jt, h as Va, L as Ct } from "./index-BmGD5jiK.js";
import { _ as Ge } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as St } from "./useResponsiveContainer-Dd7tfGkJ.js";
import { e as Ot, h as Vt, i as Ha, l as Ht, k as Ua, d as Wa, _ as Ya, a as xt, f as Ga, b as Tt, g as Ut, j as Wt } from "./SpeakerIcon.vue_vue_type_script_setup_true_lang-B7QhZ13r.js";
import { _ as Xa, c as Jt, b as Qt, d as Ka, e as Ja, a as Qa } from "./VolumeMuteIcon.vue_vue_type_script_setup_true_lang-C85Cvqdw.js";
function qa(W = {}) {
  const {
    autoPublishCamera: y = !0,
    autoPublishMicrophone: h = !0,
    skipDeviceManagement: e = !1
  } = W, { connectionState: k, disconnect: D } = dt(), {
    isCameraEnabled: m,
    isMicrophoneEnabled: g,
    isScreenShareEnabled: E,
    setCameraEnabled: A,
    setMicrophoneEnabled: M,
    setScreenShareEnabled: x,
    toggleCamera: N,
    toggleMicrophone: S,
    toggleScreenShare: X
  } = zt(), Q = e ? null : Yt({}), { switchVideoDevice: s, switchAudioInputDevice: j, switchAudioOutputDevice: O } = Q || {
    switchVideoDevice: () => I(this, null, function* () {
      throw new Error("Device management disabled");
    }),
    switchAudioInputDevice: () => I(this, null, function* () {
      throw new Error("Device management disabled");
    }),
    switchAudioOutputDevice: () => I(this, null, function* () {
      throw new Error("Device management disabled");
    })
  }, P = w(!1);
  return rt(() => {
    k.value === ue.Disconnected && P.value && (P.value = !1);
  }), {
    // State
    isActive: P,
    connectionState: k,
    // Actions
    start: (V) => I(this, null, function* () {
      if (!P.value)
        try {
          V != null && V.cameraDeviceId && (yield s(V.cameraDeviceId)), V != null && V.microphoneDeviceId && (yield j(V.microphoneDeviceId));
          const J = y && m.value, ke = h && g.value;
          J && (yield A(!0)), ke && (yield M(!0)), P.value = !0;
        } catch (J) {
          throw J;
        }
    }),
    stop: (V) => I(this, null, function* () {
      if (P.value)
        try {
          yield A(!1), yield M(!1), yield x(!1), yield D(V), P.value = !1;
        } catch (J) {
          throw J;
        }
    }),
    // Media controls
    isCameraEnabled: m,
    isMicrophoneEnabled: g,
    isScreenShareEnabled: E,
    toggleCamera: () => I(this, null, function* () {
      P.value && (yield N());
    }),
    toggleMicrophone: () => I(this, null, function* () {
      P.value && (yield S());
    }),
    toggleScreenShare: () => I(this, null, function* () {
      P.value && (yield X());
    }),
    // Direct access to base functions
    setCameraEnabled: A,
    setMicrophoneEnabled: M,
    setScreenShareEnabled: x,
    // Device switching
    switchVideoDevice: s,
    switchAudioInputDevice: j,
    switchAudioOutputDevice: O
  };
}
function Za(W = {}) {
  const y = qa(W), { localParticipant: h } = It(), e = Gt(), k = w("idle"), D = w("3"), m = w(0);
  let g = null;
  const E = () => {
    m.value = 0, g = window.setInterval(() => {
      m.value += 1;
    }, 1e3);
  }, A = () => {
    g && (clearInterval(g), g = null), m.value = 0;
  };
  return {
    // Stream-specific state
    streamState: k,
    streamDuration: m,
    countdownNumber: D,
    // State transition methods
    startConnecting: () => {
      k.value = "connecting";
    },
    setLive: () => {
      k.value = "live";
    },
    startCountdown: () => I(this, null, function* () {
      k.value = "countdown", D.value = "3", yield new Promise((s) => setTimeout(s, 1e3)), D.value = "2", yield new Promise((s) => setTimeout(s, 1e3)), D.value = "1", yield new Promise((s) => setTimeout(s, 1e3));
    }),
    showLiveMessage: () => I(this, null, function* () {
      k.value = "starting", yield new Promise((s) => setTimeout(s, 2e3)), k.value = "live";
    }),
    // Stream-specific actions
    startStream: (s) => I(this, null, function* () {
      if (k.value !== "live")
        try {
          yield y.start(s), k.value = "live", e.setLive(!0), e.setHost(h.value), E();
        } catch (j) {
          throw k.value = "idle", j;
        }
    }),
    stopStream: (s) => I(this, null, function* () {
      if (k.value === "live")
        try {
          k.value = "connecting", yield y.stop(s), e.setLive(!1), e.setHost(null), A();
        } catch (j) {
          throw j;
        }
    }),
    // Forward media controls from core host
    isCameraEnabled: y.isCameraEnabled,
    isMicrophoneEnabled: y.isMicrophoneEnabled,
    isScreenShareEnabled: y.isScreenShareEnabled,
    toggleCamera: y.toggleCamera,
    toggleMicrophone: y.toggleMicrophone,
    toggleScreenShare: y.toggleScreenShare
  };
}
function qt(W = {}) {
  const { autoConnect: y = !1 } = W, h = Xt(), { connectionState: e, disconnect: k } = dt(), { participants: D, getParticipantMetadata: m } = It(), g = Gt(), E = w(Nt.Unknown), A = n(() => D.value.find((O) => {
    const P = O != null && O.metadata ? JSON.parse(O.metadata) : null;
    return P ? P.role === "host" : !1;
  }) || null), M = n(() => {
    var O;
    return m(((O = A.value) == null ? void 0 : O.identity) || "");
  }), x = n(() => e.value === ue.Connected), N = n(() => g.state.value.title), S = n(
    () => g.state.value.description
  ), X = n(() => g.attendeeCount.value), Q = n(() => g.isLive.value);
  rt(() => {
    g.setHost(A.value);
  }), rt(() => {
    const O = h.value;
    if (!O) return;
    const P = ($) => {
      E.value = $;
    };
    return O.on("connectionQualityChanged", P), () => {
      O.off("connectionQualityChanged", P);
    };
  });
  const s = () => I(this, null, function* () {
    if (!x.value)
      try {
        g.setRole("attendee");
      } catch (O) {
        throw O;
      }
  }), j = (O) => I(this, null, function* () {
    if (x.value)
      try {
        yield k(O), E.value = Nt.Unknown;
      } catch (P) {
        throw P;
      }
  });
  return y && rt(() => {
    e.value === ue.Disconnected && s();
  }), {
    // State
    host: A,
    hostMetadata: M,
    isConnected: x,
    connectionQuality: E,
    // Actions
    joinStream: s,
    leaveStream: j,
    // Stream info
    streamTitle: N,
    streamDescription: S,
    attendeeCount: X,
    isLive: Q
  };
}
const en = { class: "stream-provider" }, tn = /* @__PURE__ */ Ye({
  __name: "StreamProvider",
  props: {
    role: { default: "attendee" },
    title: { default: "" },
    description: { default: "" },
    token: {}
  },
  setup(W) {
    const y = W;
    Ca({
      roomOptions: {
        adaptiveStream: {
          pixelDensity: "screen"
        },
        dynacast: !0,
        // Enhanced audio capture defaults for streaming
        audioCaptureDefaults: _a,
        videoCaptureDefaults: {
          resolution: {
            width: 1280,
            height: 720,
            frameRate: 30
          }
        },
        publishDefaults: {
          simulcast: !0,
          dtx: !0,
          red: !0,
          videoEncoding: {
            maxBitrate: 12e5,
            // Reduced from 1.5 Mbps
            maxFramerate: 30
          },
          screenShareEncoding: {
            maxBitrate: 2e6,
            // Increased for better text clarity
            maxFramerate: 15
            // Reduced FPS for screen share
          },
          // Enhanced audio settings for streaming
          audioPreset: {
            maxBitrate: 96e3,
            // Higher bitrate for better streaming quality
            priority: "high"
            // Prioritize audio over video for streams
          }
        }
      }
    });
    const h = xa(y.role), e = Xt(), { connectionState: k } = dt(), D = n(() => k.value === "connected"), m = It();
    lt("participants", m);
    const g = n(() => e.value && D.value && e.value.name || "");
    lt("assetId", g);
    const E = Ta({
      skipMediaPermissions: y.role === "attendee"
    });
    return lt("streamControls", E), ut(() => {
      (y.title || y.description) && h.setStreamInfo(y.title, y.description), y.token && Oa(y.token);
    }), (A, M) => (l(), p("div", en, [
      Ze(A.$slots, "default", {}, void 0, !0)
    ]));
  }
}), jo = /* @__PURE__ */ Ge(tn, [["__scopeId", "data-v-2d54301a"]]), an = /* @__PURE__ */ Ye({
  __name: "DraggableLayout",
  props: {
    initialX: { default: "0px" },
    initialY: { default: "0px" },
    constrainToParent: { type: Boolean, default: !0 },
    showHandle: { type: Boolean, default: !1 },
    handlePosition: { default: "top" },
    zIndex: {},
    absolute: { type: Boolean, default: !0 }
  },
  emits: ["drag-start", "drag-move", "drag-end", "position-change"],
  setup(W, { expose: y, emit: h }) {
    const e = W, k = h, D = w(null), m = w({
      x: e.initialX,
      y: e.initialY
    }), g = w(!1), E = w({ x: 0, y: 0 }), A = (S) => {
      if (!D.value) return;
      g.value = !0;
      const X = D.value.getBoundingClientRect();
      if (!D.value.parentElement) return;
      let s, j;
      if (S instanceof MouseEvent)
        s = S.clientX, j = S.clientY;
      else {
        const $ = S.touches[0];
        s = $.clientX, j = $.clientY, S.preventDefault();
      }
      const O = s - X.left, P = j - X.top;
      E.value = {
        x: O,
        y: P
      }, k("drag-start", {
        x: parseInt(m.value.x),
        y: parseInt(m.value.y)
      }), S instanceof MouseEvent ? (document.addEventListener("mousemove", M), document.addEventListener("mouseup", x)) : (document.addEventListener("touchmove", M, { passive: !1 }), document.addEventListener("touchend", x));
    }, M = (S) => {
      if (!g.value || !D.value) return;
      let X, Q;
      if (S instanceof MouseEvent)
        X = S.clientX, Q = S.clientY;
      else {
        const $ = S.touches[0];
        X = $.clientX, Q = $.clientY, S.preventDefault();
      }
      const s = D.value.parentElement;
      if (!s) return;
      const j = s.getBoundingClientRect();
      let O = X - j.left - E.value.x, P = Q - j.top - E.value.y;
      if (e.constrainToParent) {
        const $ = D.value.getBoundingClientRect(), B = 0, ge = j.width - $.width, K = 0, q = j.height - $.height;
        O = Math.max(B, Math.min(ge, O)), P = Math.max(K, Math.min(q, P));
      }
      m.value = {
        x: `${O}px`,
        y: `${P}px`
      }, k("drag-move", { x: O, y: P }), k("position-change", m.value);
    }, x = () => {
      g.value && (g.value = !1, k("drag-end", {
        x: parseInt(m.value.x),
        y: parseInt(m.value.y)
      }), document.removeEventListener("mousemove", M), document.removeEventListener("mouseup", x), document.removeEventListener("touchmove", M), document.removeEventListener("touchend", x));
    };
    return y({
      setPosition: (S, X) => {
        m.value = { x: S, y: X }, k("position-change", m.value);
      },
      position: m
    }), Et(() => {
      document.removeEventListener("mousemove", M), document.removeEventListener("mouseup", x), document.removeEventListener("touchmove", M), document.removeEventListener("touchend", x);
    }), (S, X) => (l(), p("div", {
      ref_key: "draggableLayout",
      ref: D,
      class: be(["draggable-layout", {
        dragging: g.value,
        "constrain-to-parent": S.constrainToParent
      }]),
      style: f({
        position: S.absolute ? "absolute" : "fixed",
        left: m.value.x,
        top: m.value.y,
        zIndex: S.zIndex,
        cursor: g.value ? "grabbing" : "grab"
      }),
      onMousedown: qe(A, ["stop"]),
      onTouchstart: qe(A, ["stop"])
    }, [
      S.showHandle ? (l(), p("div", {
        key: 0,
        class: be(["drag-handle", S.handlePosition])
      }, [
        Ze(S.$slots, "handle", {}, () => [
          X[0] || (X[0] = o("div", { class: "default-handle" }, null, -1))
        ], !0)
      ], 2)) : z("", !0),
      Ze(S.$slots, "default", {}, void 0, !0)
    ], 38));
  }
}), Zt = /* @__PURE__ */ Ge(an, [["__scopeId", "data-v-065f0480"]]), nn = /* @__PURE__ */ Ye({
  __name: "ViewersCount",
  props: {
    iconSize: { default: 14 },
    iconColor: { default: "#ffffff" },
    textColor: { default: "#ffffff" },
    backgroundColor: { default: "#1e2939" }
  },
  setup(W) {
    const y = W, h = it("participants"), { participantCount: e } = h, k = n(() => ({
      backgroundColor: y.backgroundColor
    })), D = n(() => ({
      color: y.textColor
    }));
    return (m, g) => (l(), p("div", {
      class: "viewer-count",
      style: f(k.value)
    }, [
      Y(Xa, {
        size: m.iconSize,
        color: m.iconColor
      }, null, 8, ["size", "color"]),
      o("span", {
        class: "viewer-count-text",
        style: f(D.value)
      }, ie(r(e) > 0 ? r(e) - 1 : 0), 5)
    ], 4));
  }
}), ea = /* @__PURE__ */ Ge(nn, [["__scopeId", "data-v-66d9289a"]]), on = /* @__PURE__ */ Ye({
  __name: "LiveBadge",
  props: {
    dotSize: { default: 8 },
    textSize: { default: 14 },
    backgroundColor: { default: "white" },
    textColor: { default: "#333333" },
    padding: { default: "6px 10px" },
    paused: { type: Boolean, default: !1 }
  },
  setup(W) {
    const y = W, h = n(() => ({
      backgroundColor: y.backgroundColor,
      padding: y.padding
    })), e = n(() => ({
      width: typeof y.dotSize == "number" ? `${y.dotSize}px` : y.dotSize,
      height: typeof y.dotSize == "number" ? `${y.dotSize}px` : y.dotSize
    })), k = n(() => ({
      fontSize: typeof y.textSize == "number" ? `${y.textSize}px` : y.textSize,
      color: y.textColor
    }));
    return (D, m) => (l(), p("div", {
      class: "live-badge",
      style: f(h.value)
    }, [
      o("span", {
        class: be(["live-dot", { paused: D.paused }]),
        style: f(e.value)
      }, null, 6),
      o("span", {
        class: "live-text",
        style: f(k.value)
      }, "LIVE", 4)
    ], 4));
  }
}), ta = /* @__PURE__ */ Ge(on, [["__scopeId", "data-v-9875bbcf"]]), sn = { class: "video-container" }, rn = {
  key: 0,
  class: "view-placeholder"
}, ln = {
  key: 1,
  class: "permission-button-overlay"
}, cn = { class: "permission-prompt-container" }, un = { class: "permission-prompt-text" }, dn = {
  key: 3,
  class: "status-overlay"
}, vn = {
  key: 4,
  class: "connection-minutes-banner"
}, mn = { class: "banner-content" }, pn = { class: "banner-text" }, fn = { class: "banner-message" }, hn = {
  key: 6,
  class: "loading-overlay"
}, yn = {
  key: 0,
  class: "spinner"
}, gn = {
  key: 1,
  class: "countdown-container"
}, Sn = {
  key: 2,
  class: "message-container"
}, bn = { class: "connection-message" }, kn = /* @__PURE__ */ Ye({
  __name: "StreamHostPlayer",
  props: {
    hostId: {},
    hostName: {},
    hostAvatar: {},
    videoFit: { default: "cover" },
    backgroundColor: { default: "#000000" },
    borderRadius: { default: "12px" },
    hideLoadingSpinner: { type: Boolean, default: !1 }
  },
  emits: ["stream-ready", "device", "stream-started", "stream-ended", "error"],
  setup(W, { expose: y, emit: h }) {
    gt((C) => ({
      "4b7ef3a6": e.backgroundColor,
      "43046b86": e.borderRadius,
      "3f6b4b89": je.value,
      "1ca62b31": we.value,
      "18cd1151": Fe.value,
      f473771c: Xe.value,
      cd182584: e.videoFit
    })), lt("isInsidePlayerSlot", !0);
    const e = W, k = zt(), D = Ea(), m = h, { videoDevices: g, audioInputDevices: E } = Yt({}), { connect: A, connectionState: M, transferLocalMediaToRoom: x, isConnected: N } = dt(), {
      streamState: S,
      countdownNumber: X,
      startConnecting: Q,
      setLive: s,
      startCountdown: j,
      showLiveMessage: O,
      startStream: P,
      stopStream: $
    } = Za({
      // Disable auto-publish to prevent unwanted permission requests
      autoPublishCamera: !1,
      autoPublishMicrophone: !1,
      // Skip device management to prevent useMediaDevices() calls
      skipDeviceManagement: !0
    }), B = za({
      skipAutoEnable: !1,
      // Enable eager permissions for stream host
      enabledControls: ["camera", "microphone"]
      // Enable camera and microphone controls
    }), ge = w(null), K = n(() => N()), q = () => {
      if (K.value)
        try {
          return k;
        } catch (C) {
          return null;
        }
      return null;
    }, V = n(() => K.value ? k.isCameraEnabled.value : B.isCameraEnabled.value), J = n(() => K.value ? k.isScreenShareEnabled.value : B.isScreenShareEnabled.value), ke = n(() => K.value && k.localParticipant.value && k.localParticipant.value.isSpeaking || !1), pe = n(() => D.audioLevel.value), me = w(null), oe = w(null), se = w(null), xe = w(null), { containerWidth: ce } = St(xe, {
      debounceTime: 100
      // Quick response time
    }), je = n(() => Math.max(11, Math.min(16, ce.value * 0.018)) + "px"), we = n(() => Math.max(6, Math.min(9, ce.value * 0.01)) + "px"), Fe = n(() => Math.max(80, Math.min(120, ce.value * 0.13)) + "px"), Xe = n(() => Math.max(24, Math.min(36, ce.value * 0.045)) + "px"), ee = w("Connecting to server..."), H = w(!0), Z = w(null), te = w(null), ae = w(null), F = w(!1), Te = w(!1), fe = w(!1), he = w(!1), _ = w(!1), de = n(() => {
      const C = B.cameraPermission.value.state === "denied" || B.cameraPermission.value.state === "prompt", T = B.microphonePermission.value.state === "denied" || B.microphonePermission.value.state === "prompt";
      return C || T;
    }), _e = n(() => {
      const C = B.cameraPermission.value.state === "denied" || B.cameraPermission.value.state === "prompt", T = B.microphonePermission.value.state === "denied" || B.microphonePermission.value.state === "prompt";
      return C && T ? "Allow camera and microphone" : C ? "Allow camera" : T ? "Allow microphone" : "Allow media access";
    }), Oe = n(() => {
      const C = B.cameraPermission.value.state === "denied" || B.cameraPermission.value.state === "prompt", T = B.microphonePermission.value.state === "denied" || B.microphonePermission.value.state === "prompt";
      return C && T ? "Do you want people to see and hear you in the session?" : C ? "Do you want people to see you in the session?" : T ? "Do you want people to hear you in the session?" : "Do you want to enable media access?";
    }), { remainingMinutes: Re, remainingPercentage: Ce } = Ia(), Ne = n(() => {
      const C = Re.value;
      return `${C.toLocaleString()} connection minute${C !== 1 ? "s" : ""}`;
    }), et = () => {
      F.value = !1;
    }, Ve = () => {
      F.value = !1, he.value = !0;
    }, He = () => {
      he.value = !1;
    }, tt = () => {
      He();
    }, Ue = () => I(this, null, function* () {
      he.value = !1, yield ze();
    }), Ke = () => {
      he.value = !0;
    }, G = () => {
      var C, T;
      if (me.value) {
        if (!V.value) {
          me.value.srcObject && (me.value.srcObject = null);
          return;
        }
        try {
          let t = null;
          if (K.value) {
            const u = q();
            if ((T = (C = u == null ? void 0 : u.cameraTrack) == null ? void 0 : C.value) != null && T.track) {
              const b = u.cameraTrack.value.track;
              t = new MediaStream(), "mediaStreamTrack" in b ? t.addTrack(b.mediaStreamTrack) : "id" in b && "kind" in b && t.addTrack(b);
            }
          } else
            t = B.cameraStream.value;
          t && t.getTracks().length > 0 && (me.value.srcObject = t, me.value.onloadedmetadata = () => {
            var u;
            (u = me.value) == null || u.play().catch(
              (b) => {
              }
            );
          });
        } catch (t) {
        }
      }
    }, ve = () => {
      var C, T;
      if (oe.value) {
        if (!J.value) {
          oe.value.srcObject && (oe.value.srcObject = null);
          return;
        }
        try {
          let t = null;
          if (K.value) {
            const u = q();
            if ((T = (C = u == null ? void 0 : u.screenShareTrack) == null ? void 0 : C.value) != null && T.track) {
              const b = u.screenShareTrack.value.track;
              t = new MediaStream(), "mediaStreamTrack" in b ? t.addTrack(b.mediaStreamTrack) : "id" in b && "kind" in b && t.addTrack(b);
            }
          } else
            t = B.screenShareStream.value;
          t && t.getTracks().length > 0 && (oe.value.srcObject = t, oe.value.onloadedmetadata = () => {
            var u;
            (u = oe.value) == null || u.play().catch(
              (b) => {
              }
            );
          });
        } catch (t) {
        }
      }
    }, Se = () => {
      var C, T;
      if (se.value) {
        if (!J.value || !V.value) {
          se.value.srcObject && (se.value.srcObject = null);
          return;
        }
        try {
          let t = null;
          if (K.value) {
            const u = q();
            if ((T = (C = u == null ? void 0 : u.cameraTrack) == null ? void 0 : C.value) != null && T.track) {
              const b = u.cameraTrack.value.track;
              t = new MediaStream(), "mediaStreamTrack" in b ? t.addTrack(b.mediaStreamTrack) : "id" in b && "kind" in b && t.addTrack(b);
            }
          } else
            t = B.cameraStream.value;
          t && t.getTracks().length > 0 && (se.value.srcObject = t, se.value.onloadedmetadata = () => {
            var u;
            (u = se.value) == null || u.play().catch(
              (b) => {
              }
            );
          });
        } catch (t) {
        }
      }
    }, Ee = (C) => {
      m("error", new Error("Video playback error"));
    }, We = () => {
      var t, u;
      let C, T;
      if (K.value) {
        const b = q();
        if (b) {
          const U = (t = b.cameraTrack.value) == null ? void 0 : t.track, ne = (u = b.microphoneTrack.value) == null ? void 0 : u.track;
          if (U && "getSettings" in U) {
            const d = U.getSettings();
            C = d == null ? void 0 : d.deviceId;
          }
          if (ne && "getSettings" in ne) {
            const d = ne.getSettings();
            T = d == null ? void 0 : d.deviceId;
          }
        }
      } else
        C = B.selectedCamera.value, T = B.selectedMicrophone.value;
      m("device", {
        camera: C,
        microphone: T,
        speaker: B.selectedSpeaker.value
      });
    }, Le = () => {
      m("stream-ready", {
        hasCamera: g.value.length > 0,
        hasMicrophone: E.value.length > 0,
        selectedDevices: {
          camera: void 0,
          // Will be set by parent via controls
          microphone: void 0,
          // Will be set by parent via controls
          speaker: void 0
          // Will be set by parent via controls
        }
      });
    };
    Be(
      [
        () => k.isCameraEnabled.value,
        () => k.isScreenShareEnabled.value,
        () => k.cameraTrack.value,
        () => k.screenShareTrack.value
      ],
      () => {
        G(), ve(), Se(), We();
      }
    ), Be(
      [
        () => V.value,
        () => J.value,
        () => B.cameraStream.value,
        () => B.screenShareStream.value
      ],
      () => {
        G(), ve(), Se(), We();
      }
    );
    const Ae = (C, T) => I(this, null, function* () {
      if (Z.value = C, te.value = T, S.value === "live" || S.value !== "idle")
        throw new Error("Already broadcasting or connecting");
      try {
        Q(), ee.value = "Connecting to server...", H.value = !0;
        const t = yield A({
          licenseId: Z.value,
          participantToken: te.value
        });
        if (!t.canJoin) {
          ee.value = t.message || "Cannot join the session.", t.retryInSeconds ? (H.value = !0, setTimeout(() => {
            Ae(Z.value, te.value);
          }, t.retryInSeconds * 1e3)) : H.value = !1;
          return;
        }
        ee.value = t.message || "Connecting to server...", yield j(), yield x(), yield P(), yield O(), m("stream-started"), G(), ve(), Se();
      } catch (t) {
        throw ee.value = t && typeof t == "object" && "message" in t ? t.message : "Failed to connect", H.value = !1, m(
          "error",
          t instanceof Error ? t : new Error("Failed to start stream")
        ), t;
      }
    }), ze = () => I(this, null, function* () {
      if (S.value === "live")
        try {
          ee.value = "Ending stream...", H.value = !0, yield $({
            licenseId: Z.value,
            participantToken: te.value
          }), m("stream-ended"), G(), ve(), Se(), ee.value = "This session has ended.", H.value = !1;
        } catch (C) {
          throw m(
            "error",
            C instanceof Error ? C : new Error("Failed to stop stream")
          ), C;
        }
    }), Je = () => {
      $e(), ae.value = window.setTimeout(() => {
        Ie();
      }, 1 * 60 * 1e3);
    }, $e = () => {
      ae.value && (clearTimeout(ae.value), ae.value = null);
    }, Ie = () => I(this, null, function* () {
      try {
        yield $({
          licenseId: Z.value,
          participantToken: te.value
        }), ee.value = "Connection lost. Please refresh to restart.", H.value = !1, m("stream-ended"), m("error", new Error("Reconnection timeout"));
      } catch (C) {
      }
    });
    return ut(() => {
      Le(), G(), ve(), Se();
    }), Be(
      () => k.isCameraEnabled.value,
      (C) => {
        setTimeout(() => {
          G(), J.value && Se();
        }, 500);
      }
    ), Be(Ce, (C) => {
      if (S.value !== "live")
        return;
      const { THRESHOLDS: T } = Ma;
      if (C < T.FORCE_DISCONNECT && C > 0) {
        ze();
        return;
      }
      if (C <= T.FINAL_WARNING && C >= T.FORCE_DISCONNECT && !fe.value) {
        fe.value = !0, F.value = !0;
        return;
      }
      if (C <= T.FIRST_WARNING && C > T.FINAL_WARNING && !Te.value) {
        Te.value = !0, F.value = !0;
        return;
      }
    }), Be(
      () => M.value,
      (C, T) => {
        C === ue.Reconnecting || C === ue.SignalReconnecting ? (Q(), ee.value = "Reconnecting...", H.value = !0, Je()) : (T === ue.Reconnecting || T === ue.SignalReconnecting) && C === ue.Connected && ($e(), s(), ee.value = "", H.value = !1);
      }
    ), Et(() => {
      $e(), S.value === "live" && ze().catch(console.error);
    }), y({
      startStream: Ae,
      stopStream: Ke
    }), (C, T) => (l(), p("div", {
      ref_key: "hostViewRef",
      ref: xe,
      class: "host-view"
    }, [
      o("div", sn, [
        o("video", {
          ref_key: "viewVideo",
          ref: me,
          autoplay: "",
          muted: "",
          playsinline: "",
          class: be(["view-video", { hidden: J.value }])
        }, null, 2),
        ct(o("video", {
          ref_key: "screenShareVideo",
          ref: oe,
          autoplay: "",
          muted: "",
          playsinline: "",
          class: "screen-share-view",
          onError: Ee
        }, null, 544), [
          [yt, J.value]
        ]),
        ct(Y(r(Zt), {
          ref_key: "floatingVideoContainer",
          ref: ge,
          "initial-x": "16px",
          "initial-y": "16px",
          class: "floating-video-container"
        }, {
          default: Pe(() => [
            o("video", {
              ref_key: "floatingVideoElement",
              ref: se,
              autoplay: "",
              muted: "",
              playsinline: "",
              class: "floating-video"
            }, null, 512)
          ]),
          _: 1
        }, 512), [
          [yt, J.value && V.value]
        ]),
        !V.value && !J.value ? (l(), p("div", rn, [
          Y(Mt, {
            name: C.hostName,
            image: C.hostAvatar,
            size: "medium",
            "is-speaking": ke.value,
            "audio-level": pe.value
          }, null, 8, ["name", "image", "is-speaking", "audio-level"])
        ])) : z("", !0),
        r(S) === "idle" && de.value ? (l(), p("div", ln, [
          o("div", cn, [
            o("p", un, ie(Oe.value), 1),
            o("button", {
              class: "permission-button",
              onClick: T[0] || (T[0] = (t) => _.value = !0)
            }, [
              o("span", null, ie(_e.value), 1)
            ])
          ])
        ])) : z("", !0),
        _.value ? (l(), ye(Kt, {
          key: 2,
          "camera-permission": r(B).cameraPermission.value,
          "microphone-permission": r(B).microphonePermission.value,
          onClose: T[1] || (T[1] = (t) => _.value = !1)
        }, null, 8, ["camera-permission", "microphone-permission"])) : z("", !0),
        Ze(C.$slots, "controls", {}, void 0, !0),
        Ze(C.$slots, "chat", {}, void 0, !0),
        r(S) === "live" ? (l(), p("div", dn, [
          Y(ta, {
            "dot-size": we.value,
            "text-size": je.value
          }, null, 8, ["dot-size", "text-size"]),
          Y(ea, { "icon-size": je.value }, null, 8, ["icon-size"])
        ])) : z("", !0),
        F.value ? (l(), p("div", vn, [
          o("div", mn, [
            o("div", pn, [
              T[5] || (T[5] = o("div", { class: "banner-title" }, " You're Running Low on Free Connection Minutes ", -1)),
              o("div", fn, [
                T[3] || (T[3] = _t(" You have ")),
                o("strong", null, ie(Ne.value), 1),
                T[4] || (T[4] = _t(" left. Once your free minutes are used, streaming will incur charges. Please ensure your wallet has sufficient balance to avoid interruptions. "))
              ])
            ]),
            o("div", { class: "banner-actions" }, [
              o("button", {
                class: "banner-button continue-button",
                onClick: et
              }, " Continue Streaming "),
              o("button", {
                class: "banner-button end-button",
                onClick: Ve
              }, " End Live ")
            ])
          ])
        ])) : z("", !0),
        he.value ? (l(), p("div", {
          key: 5,
          class: "modal-overlay",
          onClick: tt
        }, [
          o("div", {
            class: "modal-content",
            onClick: T[2] || (T[2] = qe(() => {
            }, ["stop"]))
          }, [
            o("div", { class: "modal-header" }, [
              T[7] || (T[7] = o("h3", { class: "modal-title" }, "End live stream?", -1)),
              o("button", {
                class: "modal-close",
                onClick: He
              }, T[6] || (T[6] = [
                o("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  o("path", {
                    d: "M18 6L6 18M6 6L18 18",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))
            ]),
            T[8] || (T[8] = o("div", { class: "modal-body" }, [
              o("p", { class: "modal-message" }, " If you exit now while you're live, it will immediately end the broadcast. ")
            ], -1)),
            o("div", { class: "modal-actions" }, [
              o("button", {
                class: "modal-button cancel-button",
                onClick: He
              }, " Cancel "),
              o("button", {
                class: "modal-button confirm-button",
                onClick: Ue
              }, " End live video ")
            ])
          ])
        ])) : z("", !0),
        r(S) !== "idle" && r(S) !== "live" ? (l(), p("div", hn, [
          r(S) === "connecting" && H.value && !C.hideLoadingSpinner ? (l(), p("div", yn)) : z("", !0),
          r(S) === "countdown" || r(S) === "starting" ? (l(), p("div", gn, [
            o("p", {
              class: be({
                "countdown-number": r(S) === "countdown",
                "live-message": r(S) === "starting"
              })
            }, ie(r(S) === "countdown" ? r(X) : "You are now live!"), 3)
          ])) : z("", !0),
          r(S) === "connecting" ? (l(), p("div", Sn, [
            o("p", bn, ie(ee.value), 1)
          ])) : z("", !0)
        ])) : z("", !0)
      ])
    ], 512));
  }
}), Oo = /* @__PURE__ */ Ge(kn, [["__scopeId", "data-v-13b7080e"]]), wn = ["data-control-size", "data-gap-size", "data-dropdown-width", "data-edge-offset"], Cn = {
  key: 0,
  class: "permission-indicator",
  title: "Camera access denied"
}, xn = {
  key: 0,
  class: "permission-indicator",
  title: "Microphone access denied"
}, Tn = {
  key: 0,
  class: "permission-indicator",
  title: "Screen sharing access denied"
}, _n = {
  key: 4,
  class: "settings-container control-item"
}, En = {
  key: 0,
  class: "controls-end"
}, zn = { class: "dropdown-content" }, In = { class: "select-wrapper" }, Mn = ["value"], Pn = ["value"], Bn = { class: "select-wrapper" }, Rn = ["value"], Ln = ["value"], An = {
  key: 0,
  class: "mic-meter-wrapper"
}, $n = { class: "select-wrapper" }, Fn = ["value"], Nn = ["value"], Dn = /* @__PURE__ */ Ye({
  __name: "StreamHostControlBar",
  props: {
    embeddedPosition: { default: "bottom" },
    containerStyle: {},
    barBackgroundColor: { default: "none" },
    buttonStyle: {},
    activeButtonStyle: {},
    hoverButtonStyle: {},
    disabledButtonStyle: {},
    iconStyle: {},
    iconColor: { default: "white" },
    activeIconColor: { default: "#4285f4" },
    dropdownStyle: {},
    dropdownItemStyle: {},
    dropdownItemHoverStyle: {},
    dropdownBackgroundColor: { default: "rgba(32, 33, 36, 0.98)" },
    textStyle: {},
    textColor: { default: "white" },
    fontFamily: {},
    borderRadius: { default: "12px" },
    padding: {},
    boxShadow: {},
    backdropFilter: {},
    controls: { default: () => [] }
  },
  emits: ["camera", "microphone", "screen-share", "camera-flip", "device", "error"],
  setup(W, { expose: y, emit: h }) {
    gt((d) => ({
      "6afd1946": te.value + "px",
      "066c35fc": de.value ? ae.value + "px" : "0",
      "2a46e11f": de.value ? _.barBackgroundColor : "transparent",
      "3bf89cee": de.value ? ae.value * 0.6 + "px" : "0",
      "291af05f": Z.value + "px",
      "3e7510a3": F.value + "px",
      "6da17cdc": _.iconColor,
      faac76b0: _.textColor,
      "22bcfbfc": r(H) + "px",
      "54a8a166": fe.value + "px",
      "3e72cac3": F.value + "px",
      "64500d76": _.dropdownBackgroundColor,
      "3611d5a9": ae.value * 0.6 + "px",
      a30f1170: Te.value + "px",
      "39f80043": te.value * 0.7 + "px",
      "21e44974": _.dropdownBackgroundColor === "none" ? "transparent" : _.dropdownBackgroundColor,
      "664f7beb": ae.value * 0.4 + "px",
      "48065b4b": ae.value + "px",
      "02c67c36": F.value * 0.75 + "px",
      "7b1b86ce": r(H) * 0.7 + "px",
      "1e6e4708": he.value * 0.5 + "px",
      "306cc12f": _.dropdownBackgroundColor === "none" ? "rgba(32, 33, 36, 0.95)" : _.dropdownBackgroundColor,
      "7a4a6546": _.barBackgroundColor === "none" ? "rgba(32, 33, 36, 0.95)" : _.barBackgroundColor,
      c3b90532: te.value
    }));
    const e = w(!0), k = () => {
      e.value = !e.value;
    }, D = n(() => !e.value || _.controls.length <= 3 ? _.controls : _.controls.slice(0, 3)), m = it("streamControls"), {
      // Device lists
      videoDevices: g,
      audioInputDevices: E,
      audioOutputDevices: A,
      // Media states
      isCameraEnabled: M,
      isMicrophoneEnabled: x,
      isScreenShareEnabled: N,
      isScreenShareSupported: S,
      hasMultipleCameras: X,
      // Browser permission states
      cameraPermission: Q,
      microphonePermission: s,
      screenSharePermission: j,
      // Selected devices
      selectedCamera: O,
      selectedMicrophone: P,
      selectedSpeaker: $,
      // Streams
      cameraStream: B,
      microphoneStream: ge,
      screenShareStream: K,
      // Control methods
      toggleCamera: q,
      toggleMicrophone: V,
      toggleScreenShare: J,
      startCamera: ke,
      stopCamera: pe,
      startMicrophone: me,
      stopMicrophone: oe,
      startScreenShare: se,
      stopScreenShare: xe,
      // Device management
      handleDeviceChange: ce,
      handleCameraFlip: je
    } = m, we = it("isInsidePlayerSlot", !1), Fe = w(null), Xe = w(null);
    ut(() => {
      if (Fe.value) {
        const d = Fe.value.parentElement;
        d && (Xe.value = d);
      }
    });
    const { containerWidth: ee, baseFontSize: H } = St(
      Xe,
      {
        baseSize: 16,
        // Base size at reference width
        referenceWidth: 800,
        // Width at which base size applies
        minSize: 12,
        // Minimum size
        maxSize: 20,
        // Maximum size
        debounceTime: 100
        // Quick response time
      }
    ), Z = n(() => {
      const R = 28 + 12 * (H.value - 12) / 8;
      return Math.max(28, Math.min(40, R));
    }), te = n(() => {
      const R = 16 + 4 * (H.value - 12) / 8;
      return Math.max(16, Math.min(20, R));
    }), ae = n(() => {
      const R = 16 + 4 * (H.value - 12) / 8;
      return Math.max(16, Math.min(20, R));
    }), F = n(() => {
      const R = 24 + 4 * (H.value - 12) / 8;
      return Math.max(24, Math.min(28, R));
    }), Te = n(() => Math.min(280, Math.max(100, ee.value * 0.8))), fe = n(() => {
      const nt = 8 + Math.min(ee.value, 1200) / 1200 * 8;
      return Math.max(8, Math.min(16, nt));
    }), he = n(() => {
      const nt = 6 + Math.min(ee.value, 1200) / 1200 * 6;
      return Math.max(6, Math.min(12, nt));
    }), _ = W;
    lt("controlsConfig", _.controls);
    const de = n(() => _.barBackgroundColor !== "none"), _e = n(() => _.embeddedPosition === "left" || _.embeddedPosition === "right"), Oe = n(() => we), Re = n(() => a(a({
      backgroundColor: _.barBackgroundColor,
      padding: _.padding,
      borderRadius: _.borderRadius,
      boxShadow: _.boxShadow,
      backdropFilter: _.backdropFilter,
      fontFamily: _.fontFamily
    }, _.barBackgroundColor === "none" && !_.containerStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    } : {}), _.containerStyle)), Ce = n(() => a(a({}, _.barBackgroundColor === "none" && !_.buttonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), _.buttonStyle)), Ne = n(() => a(a({}, _.barBackgroundColor === "none" && !_.activeButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), _.activeButtonStyle)), et = n(() => a({
      backgroundColor: _.dropdownBackgroundColor,
      borderRadius: _.borderRadius,
      boxShadow: _.boxShadow,
      fontFamily: _.fontFamily
    }, _.dropdownStyle)), Ve = n(() => a({
      color: _.textColor
    }, _.dropdownItemStyle)), He = n(() => a(a({
      color: _.textColor,
      fontFamily: _.fontFamily
    }, _.barBackgroundColor === "none" && !_.textStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), _.textStyle)), tt = () => Q.value.state === "denied" ? "Camera access denied. Please allow camera access in browser settings." : M.value ? "Turn off camera" : "Turn on camera", Ue = () => s.value.state === "denied" ? "Microphone access denied. Please allow microphone access in browser settings." : x.value ? "Mute" : "Unmute", Ke = () => j.value.state === "denied" ? "Screen sharing access denied. Please allow screen sharing in browser settings." : S ? N ? "Stop sharing" : "Share screen" : "Screen sharing not supported on this device", G = h, ve = w(!1), Se = w(null), Ee = w(!1), We = (d) => {
      d && d.stopPropagation(), ve.value = !ve.value;
    }, Le = (d) => {
      Se.value && !Se.value.contains(d.target) && (ve.value = !1);
    }, Ae = () => I(this, null, function* () {
      try {
        if (Q.value.state === "denied") {
          Ee.value = !0;
          return;
        }
        yield q(), G("camera", M.value, B.value);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to toggle camera")
        );
      }
    }), ze = () => I(this, null, function* () {
      try {
        yield ke(), G("camera", !0, B.value);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to start camera")
        );
      }
    }), Je = () => {
      try {
        pe(), G("camera", !1, null);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to stop camera")
        );
      }
    }, $e = () => I(this, null, function* () {
      try {
        if (s.value.state === "denied") {
          Ee.value = !0;
          return;
        }
        yield V(), G("microphone", x.value, ge.value);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to toggle microphone")
        );
      }
    }), Ie = () => I(this, null, function* () {
      try {
        yield me(), G("microphone", !0, ge.value);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to start microphone")
        );
      }
    }), C = () => {
      try {
        oe(), G("microphone", !1, null);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to stop microphone")
        );
      }
    }, T = () => I(this, null, function* () {
      try {
        yield J(), G("screen-share", N.value, K.value);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to toggle screen share")
        );
      }
    }), t = () => I(this, null, function* () {
      try {
        yield se(), G("screen-share", !0, K.value);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to start screen share")
        );
      }
    }), u = () => {
      try {
        xe(), G("screen-share", !1, null);
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to stop screen share")
        );
      }
    }, b = (d, re) => I(this, null, function* () {
      try {
        yield ce(d, re), G("device", d, re);
      } catch (R) {
        G(
          "error",
          R instanceof Error ? R : new Error(`Failed to change ${d} device`)
        );
      }
    }), U = () => I(this, null, function* () {
      try {
        yield je(), G("camera-flip");
      } catch (d) {
        G(
          "error",
          d instanceof Error ? d : new Error("Failed to flip camera")
        );
      }
    });
    Be(ve, (d) => {
      d ? setTimeout(() => {
        document.addEventListener("click", Le);
      }, 100) : document.removeEventListener("click", Le);
    }), y({
      // Device selections
      get selectedCamera() {
        return O.value;
      },
      get selectedMicrophone() {
        return P.value;
      },
      get selectedSpeaker() {
        return $.value;
      },
      // Stream states
      get isCameraEnabled() {
        return M.value;
      },
      get isMicrophoneEnabled() {
        return x.value;
      },
      get isScreenShareEnabled() {
        return N.value;
      },
      // Streams
      get videoStream() {
        return B.value;
      },
      get audioStream() {
        return ge.value;
      },
      get screenShareStream() {
        return K.value;
      },
      // Control methods (use wrapper methods that emit events)
      toggleCamera: Ae,
      toggleMicrophone: $e,
      toggleScreenShare: T,
      // Explicitly turn on/off (use wrapper methods that emit events)
      startCamera: ze,
      stopCamera: Je,
      startMicrophone: Ie,
      stopMicrophone: C,
      startScreenShare: t,
      stopScreenShare: u
    });
    const ne = n(() => _e.value ? e.value ? "down" : "up" : e.value ? "right" : "left");
    return (d, re) => (l(), p("div", {
      ref_key: "controlBarRef",
      ref: Fe,
      class: be(["control-bar", {
        vertical: _e.value,
        [`position-${_.embeddedPosition}`]: Oe.value,
        "screen-share-active": r(N),
        collapsed: e.value,
        "no-background": !de.value
      }]),
      style: f(Re.value),
      "data-control-size": Z.value,
      "data-gap-size": te.value,
      "data-dropdown-width": Te.value,
      "data-edge-offset": fe.value
    }, [
      Y(wa, {
        name: "controls-animation",
        tag: "div",
        class: "controls-group"
      }, {
        default: Pe(() => [
          d.controls && d.controls.length > 0 ? (l(), p(De, { key: 0 }, [
            (l(!0), p(De, null, st(D.value, (R) => (l(), p(De, { key: R }, [
              R === "camera" ? (l(), ye(at, {
                key: 0,
                active: r(M),
                title: tt(),
                "no-background": !de.value,
                style: f(
                  r(M) ? Ne.value : Ce.value
                ),
                class: be([{
                  "permission-denied": r(Q).state === "denied"
                }, "control-item"]),
                onClick: Ae
              }, {
                default: Pe(() => [
                  Y(Ot, {
                    variant: r(M) ? "on" : "mute",
                    size: F.value
                  }, null, 8, ["variant", "size"]),
                  r(Q).state === "denied" ? (l(), p("div", Cn, " ! ")) : z("", !0)
                ]),
                _: 1
              }, 8, ["active", "title", "no-background", "style", "class"])) : z("", !0),
              R === "microphone" ? (l(), ye(at, {
                key: 1,
                active: r(x),
                title: Ue(),
                "no-background": !de.value,
                style: f(
                  r(x) ? Ne.value : Ce.value
                ),
                class: be([{
                  "permission-denied": r(s).state === "denied"
                }, "control-item"]),
                onClick: $e
              }, {
                default: Pe(() => [
                  Y(Vt, {
                    variant: r(x) ? "on" : "mute",
                    size: F.value
                  }, null, 8, ["variant", "size"]),
                  r(s).state === "denied" ? (l(), p("div", xn, " ! ")) : z("", !0)
                ]),
                _: 1
              }, 8, ["active", "title", "no-background", "style", "class"])) : z("", !0),
              R === "screen-share" ? (l(), ye(at, {
                key: 2,
                active: r(N),
                disabled: !r(S),
                title: Ke(),
                "no-background": !de.value,
                style: f(
                  r(N) ? Ne.value : Ce.value
                ),
                class: be([{
                  "permission-denied": r(j).state === "denied"
                }, "control-item"]),
                onClick: re[0] || (re[0] = (nt) => r(S) ? T() : void 0)
              }, {
                default: Pe(() => [
                  Y(Ha, {
                    variant: r(N) ? "on" : "off",
                    size: F.value
                  }, null, 8, ["variant", "size"]),
                  r(j).state === "denied" ? (l(), p("div", Tn, " ! ")) : z("", !0)
                ]),
                _: 1
              }, 8, ["active", "disabled", "title", "no-background", "style", "class"])) : z("", !0),
              R === "speaker" ? (l(), ye(at, {
                key: 3,
                active: !1,
                title: "Speaker settings",
                "no-background": !de.value,
                style: f(Ce.value),
                class: "control-item",
                onClick: We
              }, {
                default: Pe(() => [
                  Y(Ht, {
                    variant: "on",
                    size: F.value
                  }, null, 8, ["size"])
                ]),
                _: 1
              }, 8, ["no-background", "style"])) : z("", !0),
              R === "settings" ? (l(), p("div", _n, [
                Y(at, {
                  active: ve.value,
                  title: "Device settings",
                  "no-background": !de.value,
                  style: f(
                    ve.value ? Ne.value : Ce.value
                  ),
                  onClick: We
                }, {
                  default: Pe(() => [
                    Y(Ua, {
                      variant: ve.value ? "on" : "off",
                      size: F.value
                    }, null, 8, ["variant", "size"])
                  ]),
                  _: 1
                }, 8, ["active", "no-background", "style"])
              ])) : z("", !0),
              R === "camera-flip" ? (l(), ye(at, {
                key: 5,
                disabled: !r(M) || !r(X),
                title: r(X) ? r(M) ? "Flip camera" : "Enable camera first" : "Camera flip not available - only one camera detected",
                "no-background": !de.value,
                style: f(Ce.value),
                class: "control-item",
                onClick: U
              }, {
                default: Pe(() => [
                  Y(Wa, { size: F.value }, null, 8, ["size"])
                ]),
                _: 1
              }, 8, ["disabled", "title", "no-background", "style"])) : z("", !0)
            ], 64))), 128)),
            d.controls.length > 3 ? (l(), ye(at, {
              key: "toggle-button",
              class: "control-item toggle-button",
              active: !1,
              title: e.value ? "Show more controls" : "Show fewer controls",
              "no-background": !de.value,
              style: f(Ce.value),
              onClick: k
            }, {
              default: Pe(() => [
                Y(Ya, {
                  variant: ne.value,
                  size: F.value
                }, null, 8, ["variant", "size"])
              ]),
              _: 1
            }, 8, ["title", "no-background", "style"])) : z("", !0)
          ], 64)) : z("", !0)
        ]),
        _: 1
      }),
      d.$slots["end-controls"] ? (l(), p("div", En, [
        Ze(d.$slots, "end-controls", {}, void 0, !0)
      ])) : z("", !0),
      ve.value ? (l(), p("div", {
        key: 1,
        ref_key: "settingsDropdown",
        ref: Se,
        class: "settings-dropdown",
        style: f(et.value)
      }, [
        o("div", zn, [
          d.controls && d.controls.includes("camera") ? (l(), p("div", {
            key: 0,
            class: "device-select",
            style: f(Ve.value)
          }, [
            o("div", In, [
              Y(Ot, {
                class: "device-icon",
                size: F.value * 0.75
              }, null, 8, ["size"]),
              o("select", {
                id: "camera-select",
                value: r(O),
                onChange: re[1] || (re[1] = (R) => b("camera", R.target.value))
              }, [
                (l(!0), p(De, null, st(r(g), (R) => (l(), p("option", {
                  key: R.deviceId,
                  value: R.deviceId
                }, ie(R.label || `Camera ${r(g).indexOf(R) + 1}`), 9, Pn))), 128))
              ], 40, Mn),
              Y(xt, {
                class: "arrow-icon",
                size: F.value * 0.75
              }, null, 8, ["size"])
            ])
          ], 4)) : z("", !0),
          d.controls && d.controls.includes("microphone") ? (l(), p("div", {
            key: 1,
            class: "device-select",
            style: f(Ve.value)
          }, [
            o("div", Bn, [
              Y(Vt, {
                class: "device-icon",
                size: F.value * 0.75
              }, null, 8, ["size"]),
              o("select", {
                id: "mic-select",
                value: r(P),
                onChange: re[2] || (re[2] = (R) => b("microphone", R.target.value))
              }, [
                (l(!0), p(De, null, st(r(E), (R) => (l(), p("option", {
                  key: R.deviceId,
                  value: R.deviceId
                }, ie(R.label || `Microphone ${r(E).indexOf(R) + 1}`), 9, Ln))), 128))
              ], 40, Rn),
              Y(xt, {
                class: "arrow-icon",
                size: F.value * 0.75
              }, null, 8, ["size"])
            ]),
            r(x) ? (l(), p("div", An, [
              Y(Pa, {
                "icon-color": _.iconColor,
                "icon-size": F.value * 0.75
              }, null, 8, ["icon-color", "icon-size"])
            ])) : (l(), p("div", {
              key: 1,
              class: "mic-disabled-message",
              style: f(He.value)
            }, " Enable microphone to see audio level ", 4))
          ], 4)) : z("", !0),
          d.controls && d.controls.includes("speaker") ? (l(), p("div", {
            key: 2,
            class: "device-select",
            style: f(Ve.value)
          }, [
            o("div", $n, [
              Y(Ht, {
                class: "device-icon",
                size: F.value * 0.75
              }, null, 8, ["size"]),
              o("select", {
                id: "speaker-select",
                value: r($),
                onChange: re[3] || (re[3] = (R) => b("speaker", R.target.value))
              }, [
                (l(!0), p(De, null, st(r(A), (R) => (l(), p("option", {
                  key: R.deviceId,
                  value: R.deviceId
                }, ie(R.label || `Speaker ${r(A).indexOf(R) + 1}`), 9, Nn))), 128))
              ], 40, Fn),
              Y(xt, {
                class: "arrow-icon",
                size: F.value * 0.75
              }, null, 8, ["size"])
            ])
          ], 4)) : z("", !0)
        ])
      ], 4)) : z("", !0),
      Ee.value ? (l(), ye(Kt, {
        key: 2,
        "camera-permission": r(Q),
        "microphone-permission": r(s),
        onClose: re[4] || (re[4] = (R) => Ee.value = !1)
      }, null, 8, ["camera-permission", "microphone-permission"])) : z("", !0)
    ], 14, wn));
  }
}), Vo = /* @__PURE__ */ Ge(Dn, [["__scopeId", "data-v-a8560bb2"]]), jn = { class: "icon-circle-outer" }, On = { class: "icon-circle-inner" }, Vn = {
  key: 2,
  class: "message-spacer"
}, Hn = { class: "message-content" }, Un = ["onClick"], Wn = ["src", "alt"], Yn = ["src"], Gn = ["title"], Xn = { class: "attachment-size" }, Kn = ["onClick"], Jn = {
  key: 0,
  class: "file-preview-thumbnail"
}, Qn = ["src", "alt"], qn = ["disabled", "title"], Zn = ["placeholder", "maxlength", "disabled"], eo = { class: "buttons-row" }, to = { class: "icons-group" }, ao = ["disabled"], no = ["disabled"], oo = ["disabled"], so = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, ro = ["stroke-dasharray"], lo = ["disabled"], io = { class: "input-wrapper" }, co = ["placeholder", "maxlength", "disabled", "onKeydown"], uo = ["disabled"], vo = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, mo = ["stroke-dasharray"], po = ["accept"], fo = /* @__PURE__ */ Ye({
  __name: "StreamChat",
  props: {
    containerStyle: {},
    messageListStyle: {},
    maxHeight: {},
    bubbleStyle: {},
    ownBubbleStyle: {},
    otherBubbleStyle: {},
    bubbleShape: { default: "square" },
    messageTextStyle: {},
    senderNameStyle: {},
    timestampStyle: {},
    fontFamily: {},
    inputContainerStyle: {},
    inputFieldStyle: {},
    sendButtonStyle: {},
    attachmentButtonStyle: {},
    emojiButtonStyle: {},
    emojiPickerConfig: {},
    emojiPickerStyle: {},
    avatarStyle: {},
    emptyStateStyle: {},
    emptyStateContentStyle: {},
    emptyStateIconStyle: {},
    emptyStateHeadingStyle: {},
    emptyStateMessageStyle: {},
    loadingIndicatorStyle: {},
    loadingSpinnerStyle: {},
    loadingTextStyle: {},
    skeletonStyle: {},
    skeletonAvatarStyle: {},
    skeletonContentStyle: {},
    skeletonNameStyle: {},
    skeletonTextStyle: {},
    scrollButtonStyle: {},
    newMessageNotificationStyle: {},
    errorNotificationStyle: {},
    errorNotificationContentStyle: {},
    errorNotificationTextStyle: {},
    errorDismissButtonStyle: {},
    filePreviewStyle: {},
    fileIconStyle: {},
    fileInfoStyle: {},
    fileNameStyle: {},
    fileSizeStyle: {},
    fileRemoveButtonStyle: {},
    attachmentContainerStyle: {},
    imageAttachmentStyle: {},
    videoAttachmentStyle: {},
    documentAttachmentStyle: {},
    downloadButtonStyle: {},
    attachmentInfoStyle: {},
    attachmentDetailsStyle: {},
    hostTagStyle: {},
    showAvatars: { type: Boolean, default: !0 },
    showTimestamps: { type: Boolean, default: !0 },
    showSenderNames: { type: Boolean, default: !0 },
    timestampFormat: { default: "HH:mm" },
    enableEmoji: { type: Boolean, default: !0 },
    enableFileAttachment: { type: Boolean, default: !0 },
    maxMessageLength: { default: 500 },
    maxFileSize: { default: 5 * 1024 * 1024 },
    allowedFileTypes: { default: "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip" },
    inputPlaceholder: { default: "Type a message..." },
    currentUserName: { default: "You" },
    avatarBackgroundColor: { default: "rgba(0, 0, 0, 0.5)" },
    enableNotificationSound: { type: Boolean, default: !1 },
    autoScroll: { type: Boolean, default: !0 },
    scrollThreshold: { default: 100 }
  },
  emits: ["message-sent", "message-received", "file-selected"],
  setup(W, { expose: y, emit: h }) {
    const e = W, k = h, D = w(), m = w(), g = w(), E = w(), A = w(), M = w(""), x = w(!0), N = w(null), S = w(null), X = w(null), Q = w(!1), s = it("isInsidePlayerSlot", !1), { messages: j, sendMessage: O, clearMessages: P } = Ba(), $ = n(() => {
      var i;
      return ((i = ge.value) == null ? void 0 : i.name) || e.currentUserName;
    }), { connectionState: B } = dt(), { localParticipant: ge } = zt(), K = n(() => "file-transfer-room"), q = n(() => B.value === ue.Connected), {
      fileMessages: V,
      isUploading: J,
      uploadProgress: ke,
      sendFile: pe,
      clearFileMessages: me
    } = Ra(K.value), { recordMessage: oe } = La(), se = Aa(), xe = Na(), {
      historicalMessages: ce,
      hasMore: je,
      isInitialLoading: we,
      isLoadingMore: Fe,
      loadMoreHistory: Xe
    } = $a({
      pageSize: 15,
      onError: (i) => {
      }
    }), ee = n(() => {
      const i = [], v = /* @__PURE__ */ new Map();
      j.value.forEach((L) => {
        const le = L.text.match(/^\[FILE:([^\]]+)\](.*)$/);
        if (le) {
          const [, Me, ot] = le;
          v.set(Me, ot);
        }
      }), j.value.forEach((L) => {
        L.text.startsWith("[FILE:") || i.push(ht(a({}, L), {
          attachment: void 0
        }));
      }), V.value.forEach((L) => {
        const le = L.isOwn ? $.value : L.senderName, Me = v.get(L.streamId) || "";
        i.push({
          id: L.id,
          text: Me,
          // Use associated text from data channel
          senderName: le,
          senderIdentity: L.senderIdentity,
          senderIdentityType: L.senderIdentityType,
          senderAvatar: L.senderAvatar,
          senderRole: L.senderRole,
          timestamp: L.timestamp,
          isOwn: L.isOwn,
          attachment: {
            id: L.streamId,
            name: L.fileName,
            size: L.fileSize,
            type: L.mimeType,
            url: L.url
          }
        });
      });
      const c = ce.value.map((L) => {
        var le;
        return ht(a({}, L), {
          isOwn: L.senderIdentity === ((le = ge.value) == null ? void 0 : le.identity)
        });
      });
      return Fa(
        c,
        i
      );
    }), H = n(() => a(a({
      fontFamily: e.fontFamily
    }, s && !e.containerStyle ? {
      background: "transparent",
      backdropFilter: "none"
    } : {}), e.containerStyle)), Z = n(() => a(a({
      maxHeight: e.maxHeight
    }, s && !e.messageListStyle ? {
      background: "transparent"
    } : {}), e.messageListStyle)), te = n(() => a(a({}, s && !e.messageTextStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.messageTextStyle)), ae = n(() => a(a({}, s && !e.senderNameStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.senderNameStyle)), F = n(() => a(a({}, s && !e.timestampStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.timestampStyle)), Te = n(() => a(a({}, s && !e.inputContainerStyle ? {
      background: "transparent",
      borderTop: "none"
    } : {}), e.inputContainerStyle)), fe = n(() => a(a({
      fontFamily: e.fontFamily
    }, s && !e.inputFieldStyle ? {
      background: "transparent",
      borderColor: "rgba(255, 255, 255)",
      backdropFilter: "none",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.inputFieldStyle)), he = n(() => a(a({}, s && !e.sendButtonStyle ? {
      background: "rgba(0, 0, 0, 0.5)",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.sendButtonStyle)), _ = n(() => a(a({}, s && !e.attachmentButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.attachmentButtonStyle)), de = n(() => a(a({}, s && !e.emojiButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.emojiButtonStyle)), _e = n(() => a(a({}, s && !e.avatarStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.avatarStyle)), Oe = n(() => a(a({}, s && !e.emptyStateStyle ? {
      background: "transparent"
    } : {}), e.emptyStateStyle)), Re = n(() => a(a({}, s && !e.emptyStateContentStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.emptyStateContentStyle)), Ce = n(() => a(a({}, s && !e.emptyStateIconStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4))"
    } : {}), e.emptyStateIconStyle)), Ne = n(() => a(a({}, s && !e.emptyStateHeadingStyle ? {
      color: "white",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateHeadingStyle)), et = n(() => a(a({}, s && !e.emptyStateMessageStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateMessageStyle)), Ve = n(() => a(a({}, s && !e.loadingIndicatorStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.loadingIndicatorStyle)), He = n(() => a(a({}, s && !e.loadingSpinnerStyle ? {
      borderColor: "rgba(255, 255, 255, 0.3)",
      borderTopColor: "white"
    } : {}), e.loadingSpinnerStyle)), tt = n(() => a(a({}, s && !e.loadingTextStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.loadingTextStyle)), Ue = n(() => a(a({}, s && !e.skeletonStyle ? {
      background: "rgba(255, 255, 255, 0.05)",
      borderTopColor: "rgba(255, 255, 255, 0.1)"
    } : {}), e.skeletonStyle)), Ke = n(() => a(a({}, s && !e.skeletonAvatarStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonAvatarStyle)), G = n(() => a(a({}, s && !e.skeletonContentStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.skeletonContentStyle)), ve = n(() => a(a({}, s && !e.skeletonNameStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonNameStyle)), Se = n(() => a(a({}, s && !e.skeletonTextStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonTextStyle)), Ee = n(() => a(a({}, s && !e.scrollButtonStyle ? {
      background: "rgba(0, 0, 0, 0.7)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.scrollButtonStyle)), We = n(() => a(a({}, s && !e.newMessageNotificationStyle ? {
      background: "rgba(0, 0, 0, 0.8)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)"
    } : {}), e.newMessageNotificationStyle)), Le = n(() => a(a({}, s && !e.errorNotificationStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.errorNotificationStyle)), Ae = n(() => a(a({}, s && !e.errorNotificationContentStyle ? {
      background: "rgba(255, 215, 0, 0.95)",
      backdropFilter: "blur(8px)"
    } : {}), e.errorNotificationContentStyle)), ze = n(() => a(a({}, s && !e.errorNotificationTextStyle ? {
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.2)"
    } : {}), e.errorNotificationTextStyle)), Je = n(() => a(a({}, s && !e.errorDismissButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.errorDismissButtonStyle)), $e = n(() => a(a({}, s && !e.filePreviewStyle ? {
      background: "rgba(240, 242, 245, 0.95)",
      backdropFilter: "blur(8px)",
      border: "1px solid rgba(255, 255, 255, 0.2)"
    } : {}), e.filePreviewStyle)), Ie = n(() => a(a({}, s && !e.fileIconStyle ? {
      background: "rgba(233, 236, 239, 0.9)",
      color: "rgba(108, 117, 125, 0.9)"
    } : {}), e.fileIconStyle)), C = n(() => a(a({}, s && !e.fileInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.fileInfoStyle)), T = n(() => a(a({}, s && !e.fileNameStyle ? {
      color: "white",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileNameStyle)), t = n(() => a(a({}, s && !e.fileSizeStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileSizeStyle)), u = n(() => a(a({}, s && !e.fileRemoveButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      color: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(4px)"
    } : {}), e.fileRemoveButtonStyle)), b = n(() => a(a({}, s && !e.attachmentContainerStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentContainerStyle)), U = n(() => a(a({}, s && !e.imageAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.imageAttachmentStyle)), ne = n(() => a(a({}, s && !e.videoAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.videoAttachmentStyle)), d = n(() => a(a({}, s && !e.documentAttachmentStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(8px)"
    } : {}), e.documentAttachmentStyle)), re = n(() => a(a({}, s && !e.downloadButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.3)",
      color: "white"
    } : {}), e.downloadButtonStyle)), R = n(() => a(a({}, s && !e.attachmentInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentInfoStyle)), nt = n(() => a(a({}, s && !e.attachmentDetailsStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentDetailsStyle)), aa = n(() => a(a({}, s && !e.hostTagStyle ? {
      background: "rgba(87, 115, 255, 0.9)",
      backdropFilter: "blur(4px)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.hostTagStyle)), bt = n(() => q.value && (M.value.trim() || N.value) && !J.value), na = (i) => {
      let v = e.bubbleStyle || {};
      s && !e.bubbleStyle && (v = a({
        background: "transparent"
      }, v));
      const c = i.isOwn ? e.ownBubbleStyle || (s ? { background: "transparent" } : {}) : e.otherBubbleStyle || (s ? { background: "transparent" } : {});
      return ht(a(a({}, v), c), {
        marginLeft: "0",
        marginRight: "auto"
      });
    }, oa = (i) => {
      const v = new Date(i);
      return e.timestampFormat === "HH:mm" ? v.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : v.toLocaleString();
    }, sa = () => I(this, null, function* () {
      if (!m.value) return;
      const { scrollTop: i, scrollHeight: v, clientHeight: c } = m.value;
      if (x.value = v - i - c < e.scrollThreshold, Q.value = !x.value && ee.value.length > 0, i < 100 && je.value && !Fe.value && !we.value) {
        const le = v;
        yield Xe(), kt(() => {
          if (m.value) {
            const ot = m.value.scrollHeight - le;
            m.value.scrollTop = i + ot;
          }
        });
      }
    }), vt = (i = !0) => {
      m.value && (m.value.scrollTop = m.value.scrollHeight);
    }, ra = (i) => {
      i.shiftKey || (i.preventDefault(), mt());
    }, la = () => {
      if (!g.value || s) return;
      const i = g.value;
      i.tagName === "TEXTAREA" && (i.style.height = "auto", i.style.height = Math.min(i.scrollHeight, 120) + "px");
    }, mt = () => I(this, null, function* () {
      if (!bt.value) return;
      const i = M.value.trim();
      if (!(!i && !N.value))
        try {
          let v = null;
          if (N.value) {
            const c = yield pe(
              N.value,
              void 0,
              // Don't pass text since attributes aren't supported
              K.value
            );
            i && (yield O(`[FILE:${c.streamId}]${i}`)), v = {
              id: c.id,
              text: i || "",
              // Text is now sent separately via data channel
              senderName: $.value,
              senderIdentity: c.senderIdentity,
              senderIdentityType: c.senderIdentityType,
              senderAvatar: c.senderAvatar,
              senderRole: c.senderRole,
              timestamp: c.timestamp,
              attachment: {
                id: c.streamId,
                name: c.fileName,
                size: c.fileSize,
                type: c.mimeType,
                url: c.url
              }
            };
          } else if (i) {
            const c = yield O(i);
            c && (v = {
              id: c.id,
              text: i || "",
              // Text is now sent separately via data channel
              senderName: $.value,
              senderIdentity: c.senderIdentity,
              senderIdentityType: c.senderIdentityType,
              senderAvatar: c.senderAvatar,
              senderRole: c.senderRole,
              timestamp: c.timestamp
            });
          }
          v && oe(v).catch((c) => null).then((c) => {
            c && k("message-sent", c);
          }), M.value = "", S.value && (URL.revokeObjectURL(S.value), S.value = null), N.value = null;
        } catch (v) {
        }
    }), ia = () => {
      var i;
      (i = E.value) == null || i.click();
    }, Pt = () => I(this, null, function* () {
      if (!(!A.value || !g.value))
        try {
          const v = a(a({}, {
            theme: s ? "dark" : "auto",
            perLine: 8,
            emojiSize: 24,
            emojiButtonSize: 32,
            searchPosition: "none"
          }), e.emojiPickerConfig), c = {};
          e.emojiPickerStyle && Object.entries(e.emojiPickerStyle).forEach(([L, le]) => {
            if (le != null) {
              const Me = L.replace(/([A-Z])/g, "-$1").toLowerCase();
              c[Me] = String(le);
            }
          }), yield se.togglePicker(
            A.value,
            (L) => {
              ca(L.native);
            },
            v,
            c
          );
        } catch (i) {
        }
    }), ca = (i) => {
      const v = g.value;
      if (!v) return;
      const c = v.selectionStart || 0, L = v.selectionEnd || 0, le = M.value, Me = le.slice(0, c) + i + le.slice(L);
      M.value = Me, kt(() => {
        const ot = c + i.length;
        v.setSelectionRange(ot, ot), v.focus();
      });
    }, ua = (i) => {
      var L;
      const v = i.target, c = (L = v.files) == null ? void 0 : L[0];
      if (c) {
        if (c.size > e.maxFileSize) {
          const le = Math.round(e.maxFileSize / 1048576);
          X.value = `File too large. Please select a file smaller than ${le} MB.`, setTimeout(() => {
            X.value = null;
          }, 5e3), v.value = "";
          return;
        }
        N.value = c, ft(c.type) && (S.value = URL.createObjectURL(c)), k("file-selected", c), v.value = "";
      }
    }, da = () => {
      J.value || (S.value && (URL.revokeObjectURL(S.value), S.value = null), N.value = null, E.value && (E.value.value = ""));
    }, Bt = (i) => {
      if (i === 0) return "0 Bytes";
      const v = 1024, c = ["Bytes", "KB", "MB", "GB"], L = Math.floor(Math.log(i) / Math.log(v));
      return Math.round(i / Math.pow(v, L) * 100) / 100 + " " + c[L];
    }, va = (i) => {
      const v = i.split(".");
      return v.length > 1 ? v[v.length - 1] : "";
    }, ma = (i, v = 20) => {
      if (i.length <= v) return i;
      const c = i.lastIndexOf(".");
      if (c === -1)
        return i.substring(0, v) + "...";
      const L = i.substring(c), le = i.substring(0, c), Me = v - L.length - 3;
      return Me <= 0 ? i.substring(0, v) + "..." : le.length <= Me ? i : le.substring(0, Me) + "..." + L;
    }, ft = (i) => i.startsWith("image/"), pa = (i) => i.startsWith("video/"), fa = (i) => {
      if (!i.url)
        return;
      const v = document.createElement("a");
      v.href = i.url, v.download = i.name, document.body.appendChild(v), v.click(), document.body.removeChild(v);
    }, ha = (i) => {
      i.url && ft(i.type) && window.open(i.url, "_blank");
    };
    return Be(ee, () => {
      e.autoScroll && x.value && kt(() => vt());
    }), Be(
      () => j.value.length,
      (i, v) => I(this, null, function* () {
        if (i > v) {
          const c = j.value[j.value.length - 1];
          if (c && !c.isOwn && (k("message-received", c), e.enableNotificationSound))
            try {
              yield xe.playSound(
                Da.MESSAGE_RECEIVED
              );
            } catch (L) {
            }
        }
      })
    ), ut(() => {
      vt(!1);
      const i = document.createElement("link");
      i.rel = "prefetch", i.href = "https://cdn.jsdelivr.net/npm/emoji-mart@5.6.0/dist/browser.js", document.head.appendChild(i);
      const v = document.createElement("link");
      v.rel = "prefetch", v.href = "https://cdn.jsdelivr.net/npm/@emoji-mart/data", document.head.appendChild(v);
    }), y({
      // Methods
      sendMessage: mt,
      clearMessages: () => {
        P(), me();
      },
      scrollToBottom: vt,
      // State
      messages: ee,
      isConnected: n(() => q.value),
      messageInput: M,
      // Refs
      inputRef: g
    }), (i, v) => (l(), p("div", {
      ref_key: "chatContainerRef",
      ref: D,
      class: be(["stream-chat", { "inside-player": r(s) }]),
      style: f(H.value)
    }, [
      o("div", {
        ref_key: "messageListRef",
        ref: m,
        class: "message-list",
        style: f(Z.value),
        onScroll: sa
      }, [
        r(Fe) ? (l(), p("div", {
          key: 0,
          class: "loading-more-indicator",
          style: f(Ve.value)
        }, [
          o("div", {
            class: "loading-spinner",
            style: f(He.value)
          }, null, 4),
          o("span", {
            class: "loading-text",
            style: f(tt.value)
          }, "Loading older messages...", 4)
        ], 4)) : z("", !0),
        !r(we) && ee.value.length === 0 && !r(s) ? (l(), p("div", {
          key: 1,
          class: "empty-state",
          style: f(Oe.value)
        }, [
          o("div", {
            class: "empty-state-content",
            style: f(Re.value)
          }, [
            o("div", {
              class: "empty-state-icon",
              style: f(Ce.value)
            }, [
              o("div", jn, [
                o("div", On, [
                  Y(Ga, { size: 20 })
                ])
              ])
            ], 4),
            o("h3", {
              class: "empty-state-heading",
              style: f(Ne.value)
            }, ie(q.value ? "No conversations yet" : "Welcome to Chat"), 5),
            o("p", {
              class: "empty-state-message",
              style: f(et.value)
            }, ie(q.value ? "Start a new chat to get the conversation going!" : "Start the session to get conversation going!"), 5)
          ], 4)
        ], 4)) : r(we) ? z("", !0) : (l(), p("div", Vn)),
        (l(!0), p(De, null, st(ee.value, (c) => (l(), p("div", {
          key: c.id,
          class: be(["message-wrapper", { "own-message": c.isOwn }])
        }, [
          i.showAvatars ? (l(), p("div", {
            key: 0,
            class: "message-avatar",
            style: f(_e.value)
          }, [
            Y(Mt, {
              name: c.senderName,
              image: c.senderAvatar,
              size: "small",
              "background-color": i.avatarBackgroundColor
            }, null, 8, ["name", "image", "background-color"])
          ], 4)) : z("", !0),
          o("div", Hn, [
            i.showSenderNames ? (l(), p("div", {
              key: 0,
              class: "message-sender",
              style: f(ae.value)
            }, [
              _t(ie(c.senderName) + " ", 1),
              c.senderRole === "host" ? (l(), p("span", {
                key: 0,
                class: "host-tag",
                style: f(aa.value)
              }, "Host", 4)) : z("", !0),
              i.showTimestamps ? (l(), p("span", {
                key: 1,
                class: "message-timestamp inline",
                style: f(F.value)
              }, ie(oa(c.timestamp)), 5)) : z("", !0)
            ], 4)) : z("", !0),
            o("div", {
              class: be(["message-bubble", `bubble-${i.bubbleShape}`]),
              style: f(na(c))
            }, [
              c.text ? (l(), p("p", {
                key: 0,
                class: "message-text preserve-whitespace",
                style: f(te.value)
              }, ie(c.text), 5)) : z("", !0),
              c.attachment ? (l(), p("div", {
                key: 1,
                class: "message-attachment-container",
                style: f(b.value)
              }, [
                ft(c.attachment.type) ? (l(), p("div", {
                  key: 0,
                  class: "message-attachment image-attachment",
                  style: f(U.value),
                  onClick: (L) => ha(c.attachment)
                }, [
                  o("img", {
                    src: c.attachment.url || "#",
                    alt: c.attachment.name,
                    class: "attachment-preview-image"
                  }, null, 8, Wn)
                ], 12, Un)) : pa(c.attachment.type) ? (l(), p("div", {
                  key: 1,
                  class: "message-attachment video-attachment",
                  style: f(ne.value)
                }, [
                  o("video", {
                    src: c.attachment.url || "#",
                    class: "attachment-preview-video",
                    controls: "",
                    preload: "metadata"
                  }, " Your browser does not support the video tag. ", 8, Yn)
                ], 4)) : (l(), p("div", {
                  key: 2,
                  class: "message-attachment document-attachment",
                  style: f(d.value)
                }, [
                  o("div", {
                    class: "attachment-info",
                    style: f(R.value)
                  }, [
                    Y(Tt, { size: 20 }),
                    o("div", {
                      class: "attachment-details",
                      style: f(nt.value)
                    }, [
                      o("span", {
                        class: "attachment-name",
                        title: c.attachment.name
                      }, ie(ma(c.attachment.name)), 9, Gn),
                      o("span", Xn, ie(Bt(c.attachment.size)), 1)
                    ], 4)
                  ], 4),
                  o("button", {
                    type: "button",
                    class: "download-button",
                    style: f(re.value),
                    title: "Download",
                    onClick: (L) => fa(c.attachment)
                  }, v[6] || (v[6] = [
                    o("svg", {
                      width: "20",
                      height: "20",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      o("path", { d: "M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z" }),
                      o("path", { d: "M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z" })
                    ], -1)
                  ]), 12, Kn)
                ], 4))
              ], 4)) : z("", !0)
            ], 6)
          ])
        ], 2))), 128))
      ], 36),
      r(we) ? (l(), p("div", {
        key: 0,
        class: "initial-loading-bottom",
        style: f(Ue.value)
      }, [
        (l(!0), p(De, null, st(r(s) ? 2 : 3, (c) => (l(), p("div", {
          key: c,
          class: "message-skeleton"
        }, [
          o("div", {
            class: "skeleton-avatar",
            style: f(Ke.value)
          }, null, 4),
          o("div", {
            class: "skeleton-content",
            style: f(G.value)
          }, [
            o("div", {
              class: "skeleton-name",
              style: f(ve.value)
            }, null, 4),
            o("div", {
              class: "skeleton-text",
              style: f(Se.value)
            }, null, 4),
            r(s) ? z("", !0) : (l(), p("div", {
              key: 0,
              class: "skeleton-text short",
              style: f(Se.value)
            }, null, 4))
          ], 4)
        ]))), 128))
      ], 4)) : z("", !0),
      Y(At, { name: "new-message-notification" }, {
        default: Pe(() => [
          Q.value && !x.value ? (l(), p("div", {
            key: 0,
            class: "new-message-notification",
            style: f(We.value),
            onClick: v[0] || (v[0] = (c) => vt(!0))
          }, v[7] || (v[7] = [
            o("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              o("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1),
            o("span", { class: "new-message-text" }, "See latest", -1)
          ]), 4)) : z("", !0)
        ]),
        _: 1
      }),
      Y(At, { name: "scroll-button" }, {
        default: Pe(() => [
          Q.value && x.value ? (l(), p("button", {
            key: 0,
            type: "button",
            class: be(["scroll-to-bottom-button", { "inside-player": r(s) }]),
            style: f(Ee.value),
            onClick: v[1] || (v[1] = (c) => vt(!0))
          }, v[8] || (v[8] = [
            o("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              o("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1)
          ]), 6)) : z("", !0)
        ]),
        _: 1
      }),
      X.value ? (l(), p("div", {
        key: 1,
        class: "file-size-error-notification",
        style: f(Le.value)
      }, [
        o("div", {
          class: "error-content",
          style: f(Ae.value)
        }, [
          o("span", {
            class: "error-text",
            style: f(ze.value)
          }, ie(X.value), 5),
          o("button", {
            type: "button",
            class: "error-dismiss-button",
            style: f(Je.value),
            onClick: v[2] || (v[2] = (c) => X.value = null)
          }, " × ", 4)
        ], 4)
      ], 4)) : z("", !0),
      o("form", {
        class: "input-container",
        style: f(Te.value),
        onSubmit: v[5] || (v[5] = qe(() => {
        }, ["prevent"]))
      }, [
        r(s) ? (l(), p(De, { key: 1 }, [
          i.enableEmoji ? (l(), p("button", {
            key: 0,
            ref_key: "emojiButtonRef",
            ref: A,
            type: "button",
            class: "emoji-button",
            style: f(de.value),
            disabled: !q.value || r(se).isLoading.value,
            onClick: Pt
          }, [
            Y(Ut, { size: 20 })
          ], 12, lo)) : z("", !0),
          o("div", io, [
            ct(o("input", {
              id: "message-input",
              ref_key: "inputRef",
              ref: g,
              "onUpdate:modelValue": v[4] || (v[4] = (c) => M.value = c),
              type: "text",
              class: "message-input",
              style: f(fe.value),
              placeholder: i.inputPlaceholder,
              maxlength: i.maxMessageLength,
              disabled: !q.value,
              onKeydown: $t(qe(mt, ["prevent"]), ["enter"])
            }, null, 44, co), [
              [Ft, M.value]
            ])
          ]),
          o("button", {
            type: "button",
            class: "send-button",
            style: f(he.value),
            disabled: !bt.value,
            onClick: qe(mt, ["prevent"])
          }, [
            r(J) ? (l(), p("svg", vo, [
              v[11] || (v[11] = o("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                opacity: "0.2"
              }, null, -1)),
              o("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-dasharray": `${r(ke) * 50.3} 50.3`,
                transform: "rotate(-90 10 10)",
                class: "progress-ring-circle"
              }, null, 8, mo)
            ])) : (l(), ye(Wt, {
              key: 1,
              size: 20
            }))
          ], 12, uo)
        ], 64)) : (l(), p(De, { key: 0 }, [
          N.value ? (l(), p("div", {
            key: 0,
            class: "file-preview",
            style: f($e.value)
          }, [
            S.value && ft(N.value.type) ? (l(), p("div", Jn, [
              o("img", {
                src: S.value,
                alt: N.value.name
              }, null, 8, Qn)
            ])) : (l(), p("div", {
              key: 1,
              class: "file-icon",
              style: f(Ie.value)
            }, [
              Y(Tt, { size: 24 })
            ], 4)),
            o("div", {
              class: "file-info",
              style: f(C.value)
            }, [
              o("div", {
                class: "file-name",
                style: f(T.value)
              }, ie(N.value.name), 5),
              o("div", {
                class: "file-size",
                style: f(t.value)
              }, ie(Bt(N.value.size)) + ", " + ie(va(N.value.name)), 5)
            ], 4),
            o("button", {
              type: "button",
              class: "file-remove-button",
              style: f(u.value),
              disabled: r(J),
              title: r(J) ? "Upload in progress" : "Remove file",
              onClick: da
            }, v[9] || (v[9] = [
              o("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                o("path", { d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" })
              ], -1)
            ]), 12, qn)
          ], 4)) : z("", !0),
          ct(o("textarea", {
            id: "message-input",
            ref_key: "inputRef",
            ref: g,
            "onUpdate:modelValue": v[3] || (v[3] = (c) => M.value = c),
            class: "message-input standalone",
            style: f(fe.value),
            placeholder: i.inputPlaceholder,
            maxlength: i.maxMessageLength,
            disabled: !q.value,
            rows: "2",
            onKeydown: $t(ra, ["enter"]),
            onInput: la
          }, null, 44, Zn), [
            [Ft, M.value]
          ]),
          o("div", eo, [
            o("div", to, [
              i.enableEmoji ? (l(), p("button", {
                key: 0,
                ref_key: "emojiButtonRef",
                ref: A,
                type: "button",
                class: "emoji-button",
                style: f(de.value),
                disabled: !q.value || r(se).isLoading.value,
                onClick: Pt
              }, [
                Y(Ut, { size: 20 })
              ], 12, ao)) : z("", !0),
              i.enableFileAttachment ? (l(), p("button", {
                key: 1,
                type: "button",
                class: "attachment-button",
                style: f(_.value),
                disabled: !q.value,
                onClick: ia
              }, [
                Y(Tt, { size: 20 })
              ], 12, no)) : z("", !0)
            ]),
            o("button", {
              type: "button",
              class: "send-button",
              style: f(he.value),
              disabled: !bt.value,
              onClick: qe(mt, ["prevent"])
            }, [
              r(J) ? (l(), p("svg", so, [
                v[10] || (v[10] = o("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  opacity: "0.2"
                }, null, -1)),
                o("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-dasharray": `${r(ke) * 50.3} 50.3`,
                  transform: "rotate(-90 10 10)",
                  class: "progress-ring-circle"
                }, null, 8, ro)
              ])) : (l(), ye(Wt, {
                key: 1,
                size: 20
              }))
            ], 12, oo)
          ])
        ], 64))
      ], 36),
      o("input", {
        ref_key: "fileInputRef",
        ref: E,
        type: "file",
        accept: i.allowedFileTypes,
        style: { display: "none" },
        onChange: ua
      }, null, 40, po)
    ], 6));
  }
}), Ho = /* @__PURE__ */ Ge(fo, [["__scopeId", "data-v-fb9e4dc1"]]);
function ho(W) {
  const y = w(!1), h = w(!1), e = w(!1), k = wt(), D = wt(), m = wt(), g = w(!1), E = w(0);
  let A = null;
  return rt((M) => {
    const x = W.value;
    if (!x) {
      y.value = !1, h.value = !1, e.value = !1, k.value = void 0, D.value = void 0, m.value = void 0, g.value = !1, E.value = 0, A && (clearInterval(A), A = null);
      return;
    }
    const N = () => {
      const $ = x.getTrackPublication(pt.Source.ScreenShare);
      m.value = void 0, m.value = $, $ && $.track && !$.isMuted ? e.value = !0 : e.value = !1;
    }, S = () => {
      g.value = x.isSpeaking, E.value = x.audioLevel;
    }, Q = ja(x).subscribe({
      next: ($) => {
        y.value = $.isCameraEnabled, h.value = $.isMicrophoneEnabled, k.value = $.cameraTrack, D.value = $.microphoneTrack, N();
      },
      error: ($) => {
      }
    }), s = ($) => {
      $.source === pt.Source.ScreenShare && N();
    }, j = ($) => {
      $.source === pt.Source.ScreenShare && N();
    }, O = ($, B) => {
      B.source === pt.Source.ScreenShare && N();
    }, P = ($, B) => {
      B.source === pt.Source.ScreenShare && N();
    };
    x.on(Qe.TrackPublished, s), x.on(Qe.TrackUnpublished, j), x.on(Qe.TrackSubscribed, O), x.on(Qe.TrackUnsubscribed, P), x.on(Dt.IsSpeakingChanged, S), N(), S(), A = window.setInterval(() => {
      x.audioLevel !== E.value && (E.value = x.audioLevel);
    }, 50), M(() => {
      Q.unsubscribe(), x.off(Qe.TrackPublished, s), x.off(Qe.TrackUnpublished, j), x.off(Qe.TrackSubscribed, O), x.off(Qe.TrackUnsubscribed, P), x.off(Dt.IsSpeakingChanged, S), A && (clearInterval(A), A = null);
    });
  }), {
    isCameraEnabled: y,
    isMicrophoneEnabled: h,
    isScreenShareEnabled: e,
    cameraTrack: k,
    microphoneTrack: D,
    screenShareTrack: m,
    isSpeaking: g,
    audioLevel: E
  };
}
const yo = { class: "video-container" }, go = {
  key: 0,
  class: "loading-overlay"
}, So = {
  key: 0,
  class: "spinner"
}, bo = { class: "loading-text" }, ko = {
  key: 1,
  class: "host-avatar-placeholder"
}, wo = {
  key: 2,
  class: "stream-info-overlay"
}, Co = { class: "status-bar" }, xo = /* @__PURE__ */ Ye({
  __name: "StreamAttendeePlayer",
  props: {
    licenseId: {},
    attendeeId: {},
    attendeeName: {},
    attendeeAvatar: {},
    videoFit: { default: "cover" },
    backgroundColor: { default: "#000000" },
    autoJoin: { type: Boolean, default: !0 },
    hideLoadingSpinner: { type: Boolean, default: !1 }
  },
  emits: ["stream-joined", "stream-left", "stream-ended", "recording-available", "session-started-at"],
  setup(W, { expose: y, emit: h }) {
    gt((t) => ({
      "299d9c90": e.backgroundColor,
      "11b25813": e.videoFit
    })), lt("isInsidePlayerSlot", !0);
    const e = W, k = h, D = w(null), m = w(null), g = w(null), E = w(null), A = w(null), { containerWidth: M } = St(D, {
      debounceTime: 100
    }), x = n(() => M.value < 768 ? 48 : 36), N = n(() => M.value < 768 ? 6 : 8), S = n(() => M.value < 768 ? 12 : 14), X = n(() => M.value < 768 ? "4px 8px" : "6px 10px"), { connect: Q, connectionState: s } = dt(), {
      host: j,
      hostMetadata: O,
      isConnected: P,
      joinStream: $,
      leaveStream: B
    } = qt(), ge = n(() => j.value), {
      isCameraEnabled: K,
      isMicrophoneEnabled: q,
      isScreenShareEnabled: V,
      cameraTrack: J,
      microphoneTrack: ke,
      screenShareTrack: pe,
      isSpeaking: me,
      audioLevel: oe
    } = ho(ge), se = it("streamControls");
    if (!se)
      throw new Error("StreamAttendeePlayer must be used within StreamProvider");
    const {
      setVideoElement: xe,
      isPlaying: ce,
      togglePlay: je,
      isMuted: we,
      toggleMute: Fe,
      setVolume: Xe,
      volume: ee
    } = se, H = w(""), Z = w(!0), te = w(null), ae = /* @__PURE__ */ new Map();
    let F = null;
    const Te = w(null), fe = (t) => {
      const u = ae.get(t);
      u && (u.forEach((b) => {
        "detach" in b && typeof b.detach == "function" && b.detach(t);
      }), ae.delete(t));
    }, he = (t, u) => I(this, null, function* () {
      if (!t || !u) return !1;
      if ("attach" in t && typeof t.attach == "function") {
        const b = ae.get(u), U = b != null && b.size ? Array.from(b).some((d) => "kind" in d && d.kind === "video") : !1, ne = "kind" in t && t.kind === "audio";
        return U && ne || fe(u), t.attach(u), ae.has(u) || ae.set(u, /* @__PURE__ */ new Set()), ae.get(u).add(t), u instanceof HTMLVideoElement && _(u), !0;
      }
      return !1;
    }), _ = (t) => {
      t && (t.volume = we.value ? 0 : ee.value, t.muted = we.value, ce.value && t.paused ? t.play().catch((u) => {
      }) : !ce.value && !t.paused && t.pause());
    }, de = n(() => !!(H.value || s.value === ue.Connecting || s.value === ue.Reconnecting || s.value === ue.SignalReconnecting)), _e = /* @__PURE__ */ new Map(), Oe = (t) => I(this, null, function* () {
      if (!t) return !1;
      try {
        _e.has(t) && _e.delete(t);
        const u = t.play();
        return _e.set(t, u), yield u, _e.delete(t), !0;
      } catch (u) {
        return _e.delete(t), u instanceof Error && u.name === "AbortError", !1;
      }
    });
    let Re = null;
    const Ce = () => {
      Re && clearTimeout(Re), Re = setTimeout(() => {
        He();
      }, 100);
    }, Ne = () => I(this, null, function* () {
      var t, u;
      if (m.value)
        try {
          if (m.value.srcObject && (m.value.srcObject = null), K.value && !V.value) {
            const b = (t = J.value) == null ? void 0 : t.track;
            if (b) {
              const U = yield he(
                b,
                m.value
              );
            }
          } else
            fe(m.value);
          if (!V.value && q.value) {
            const b = (u = ke.value) == null ? void 0 : u.track;
            if (b && !(yield he(
              b,
              m.value
            ))) {
              if ("mediaStreamTrack" in b) {
                const ne = new MediaStream();
                ne.addTrack(b.mediaStreamTrack), (!ae.has(m.value) || ae.get(m.value).size === 0) && (m.value.srcObject = ne, yield Oe(m.value), _(m.value));
              }
            }
          }
        } catch (b) {
        }
    }), et = () => I(this, null, function* () {
      var t, u;
      if (g.value) {
        if (!V.value || !((t = pe.value) != null && t.track)) {
          fe(g.value), g.value.srcObject && (g.value.srcObject = null);
          return;
        }
        try {
          g.value.srcObject && (g.value.srcObject = null);
          const b = pe.value.track;
          if (b) {
            const U = yield he(
              b,
              g.value
            );
          }
          if (q.value) {
            const U = (u = ke.value) == null ? void 0 : u.track;
            if (U && !(yield he(
              U,
              g.value
            ))) {
              if ("mediaStreamTrack" in U) {
                const d = new MediaStream();
                d.addTrack(U.mediaStreamTrack), (!ae.has(g.value) || ae.get(g.value).size === 0) && (g.value.srcObject = d, yield Oe(g.value), _(g.value));
              }
            }
          }
        } catch (b) {
        }
      }
    }), Ve = () => I(this, null, function* () {
      var u;
      if (!E.value) return;
      if (!K.value || !V.value) {
        fe(E.value), E.value.srcObject && (E.value.srcObject = null);
        return;
      }
      const t = (u = J.value) == null ? void 0 : u.track;
      if (t)
        try {
          if (E.value.srcObject && (E.value.srcObject = null), !(yield he(
            t,
            E.value
          ))) {
            if ("mediaStreamTrack" in t) {
              const U = new MediaStream();
              U.addTrack(t.mediaStreamTrack), E.value.srcObject = U, yield Oe(E.value);
            }
          }
        } catch (b) {
        }
    }), He = () => I(this, null, function* () {
      yield Promise.all([
        Ne(),
        et(),
        Ve()
      ]);
    }), tt = () => {
      Ce();
    };
    Be(
      [
        K,
        q,
        V,
        J,
        ke,
        pe
      ],
      () => {
        tt();
      },
      { deep: !0 }
    );
    const Ue = () => {
      Ae.value = !0, je();
    };
    Be(
      [V, m, g],
      ([t]) => {
        const u = t ? g.value : m.value;
        if (u && u !== se.currentVideoElement.value && (xe(u), !Ie.has(u))) {
          const b = $e(u);
          b && Ie.set(u, b);
        }
      },
      { immediate: !0 }
    ), Be(
      E,
      (t) => {
        if (t && !Ie.has(t)) {
          const u = $e(t);
          u && Ie.set(t, u);
        }
      },
      { immediate: !0 }
    );
    const Ke = () => I(this, null, function* () {
      try {
        const { state: t, recordingEnabled: u } = yield jt.getLiveSessionState(e.licenseId);
        if (t === Ct.COMPLETED) {
          try {
            yield B({
              licenseId: e.licenseId,
              participantToken: te.value
            });
          } catch (b) {
          }
          H.value = u ? "This session has ended. A recording will be available soon." : "This session has ended.", Z.value = !1, k("stream-ended"), F && (clearInterval(F), F = null);
        } else t === Ct.DISCONNECTED ? (H.value = "The host is reconnecting. Please wait...", Z.value = !0) : t === Ct.LIVE && (H.value = "Waiting for host...", Z.value = !0);
      } catch (t) {
      }
    }), G = () => I(this, null, function* () {
      F && (clearInterval(F), F = null), yield Ke(), F = window.setInterval(Ke, 5e3);
    }), ve = () => {
      F && (clearInterval(F), F = null);
    }, Se = () => {
      Ee(), Te.value = window.setTimeout(() => {
        We();
      }, 1 * 60 * 1e3);
    }, Ee = () => {
      Te.value && (clearTimeout(Te.value), Te.value = null);
    }, We = () => I(this, null, function* () {
      try {
        yield B({
          licenseId: e.licenseId,
          participantToken: te.value
        }), H.value = "Connection lost. Please refresh to rejoin.", Z.value = !1, k("stream-ended");
      } catch (t) {
      }
    }), Le = w(!1), Ae = w(!1), ze = w(!1), Je = () => {
      document.hidden ? ze.value = !0 : ze.value;
    }, $e = (t) => {
      if (!t) return;
      const u = () => {
        const U = K.value || V.value;
        (ze.value || U) && (ce.value || (ce.value = !0), ze.value = !1);
      }, b = () => {
        const U = K.value || V.value;
        (Ae.value || U) && ce.value && (ce.value = !1), Ae.value = !1;
      };
      return t.addEventListener("play", u), t.addEventListener("pause", b), () => {
        t.removeEventListener("play", u), t.removeEventListener("pause", b);
      };
    }, Ie = /* @__PURE__ */ new Map();
    Be(
      () => s.value,
      (t, u) => I(this, null, function* () {
        t === ue.Connected && (Le.value = !0, H.value = "", Z.value = !1), t === ue.Disconnected && Le.value && (yield G(), Le.value = !1), t === ue.Reconnecting || t === ue.SignalReconnecting ? (H.value = "Reconnecting...", Z.value = !0, Se()) : (u === ue.Reconnecting || u === ue.SignalReconnecting) && t === ue.Connected && (Ee(), Le.value = !0, H.value = "", Z.value = !1);
      })
    ), rt(() => I(this, null, function* () {
      P.value && !j.value ? yield G() : P.value && j.value && F && (clearInterval(F), F = null, H.value = "", Z.value = !1);
    }));
    const C = (t, u) => I(this, null, function* () {
      var b;
      u && (te.value = u);
      try {
        Z.value = !0, H.value = H.value ? H.value : "Connecting to stream...";
        const U = te.value ? te.value : (b = yield jt.generateLiveSessionToken(t, {
          id: e.attendeeId,
          name: e.attendeeName,
          role: Va.ATTENDEE,
          avatar: e.attendeeAvatar
        })) == null ? void 0 : b.token;
        if (!U) {
          H.value = "Cannot join the stream.", Z.value = !1;
          return;
        }
        te.value = U;
        const ne = yield Q({
          licenseId: e.licenseId,
          participantToken: U,
          skipMediaTransfer: !0
          // Attendees don't need to publish any media
        });
        if (ne.startedAt && k("session-started-at", ne.startedAt), ne.recordingAvailable && k("recording-available", ne.recordingAvailable), !ne.canJoin) {
          H.value = ne.message || "Cannot join the stream.", ne.retryInSeconds ? (setTimeout(() => I(this, null, function* () {
            yield C(t, te.value);
          }), ne.retryInSeconds * 1e3), Z.value = !0) : Z.value = !1;
          return;
        }
        H.value = ne.message || "Connecting to stream...", yield $(), H.value = "", k("stream-joined");
      } catch (U) {
        H.value = U && typeof U == "object" && "message" in U ? U.message : "Failed to connect", Z.value = !1;
      }
    }), T = () => I(this, null, function* () {
      yield B({
        licenseId: e.licenseId,
        participantToken: te.value
      }), k("stream-left"), ve();
    });
    return ut(() => {
      e.autoJoin && C(e.licenseId, te.value), document.addEventListener("visibilitychange", Je);
    }), Et(() => I(this, null, function* () {
      if (Re && clearTimeout(Re), Ee(), Ie.forEach((t, u) => {
        t();
      }), Ie.clear(), m.value && fe(m.value), g.value && fe(g.value), E.value && fe(E.value), P.value)
        try {
          yield B({
            licenseId: e.licenseId,
            participantToken: te.value
          });
        } catch (t) {
        }
      F && (clearInterval(F), F = null), document.removeEventListener("visibilitychange", Je);
    })), y({
      joinStream: C,
      leaveStream: T,
      // Expose video state and controls for external use
      isPlaying: ce,
      isMuted: we,
      volume: ee,
      togglePlayPause: Ue,
      toggleMute: Fe,
      setVolume: Xe
    }), (t, u) => {
      var b, U;
      return l(), p("div", {
        ref_key: "playerRef",
        ref: D,
        class: "attendee-player"
      }, [
        o("div", yo, [
          o("video", {
            ref_key: "videoElement",
            ref: m,
            playsinline: "",
            autoplay: "",
            class: be(["stream-video", { hidden: r(V) }]),
            onClick: Ue
          }, null, 2),
          ct((l(), p("video", {
            key: ((b = r(pe)) == null ? void 0 : b.trackSid) || "no-screen-share",
            ref_key: "screenShareElement",
            ref: g,
            class: "screen-share-video",
            playsinline: "",
            autoplay: ""
          })), [
            [yt, r(V)]
          ]),
          ct(Y(r(Zt), {
            ref_key: "floatingVideoContainer",
            ref: A,
            "initial-x": "16px",
            "initial-y": "16px",
            class: "floating-video-container"
          }, {
            default: Pe(() => [
              o("video", {
                ref_key: "floatingVideoElement",
                ref: E,
                class: "floating-video",
                autoplay: "",
                playsinline: "",
                muted: ""
              }, null, 512)
            ]),
            _: 1
          }, 512), [
            [yt, r(V) && r(K)]
          ]),
          de.value ? (l(), p("div", go, [
            Z.value && !t.hideLoadingSpinner ? (l(), p("div", So)) : z("", !0),
            o("p", bo, ie(H.value || "Connecting to stream..."), 1)
          ])) : z("", !0),
          r(P) && r(j) && !r(K) && !r(V) ? (l(), p("div", ko, [
            Y(Mt, {
              name: r(j).name || "Host",
              image: (U = r(O)) == null ? void 0 : U.avatar,
              size: "medium",
              "is-speaking": r(me),
              "audio-level": r(oe)
            }, null, 8, ["name", "image", "is-speaking", "audio-level"])
          ])) : z("", !0),
          r(P) ? (l(), p("div", wo, [
            o("div", Co, [
              Y(ta, {
                "dot-size": N.value,
                "text-size": S.value,
                padding: X.value,
                paused: !r(ce)
              }, null, 8, ["dot-size", "text-size", "padding", "paused"]),
              Y(ea, { "icon-size": 14 })
            ]),
            r(K) || r(V) ? (l(), p("button", {
              key: 0,
              class: be(["play-pause-button", { playing: r(ce) }]),
              onClick: qe(Ue, ["stop"])
            }, [
              r(ce) ? (l(), ye(Qt, {
                key: 1,
                size: x.value,
                color: "white"
              }, null, 8, ["size"])) : (l(), ye(Jt, {
                key: 0,
                size: x.value,
                color: "white"
              }, null, 8, ["size"]))
            ], 2)) : z("", !0)
          ])) : z("", !0),
          r(P) ? Ze(t.$slots, "controls", { key: 3 }, void 0, !0) : z("", !0),
          Ze(t.$slots, "chat", {}, void 0, !0)
        ])
      ], 512);
    };
  }
}), Uo = /* @__PURE__ */ Ge(xo, [["__scopeId", "data-v-0270311a"]]), To = { class: "controls-container" }, _o = { class: "controls-left" }, Eo = ["value"], zo = { class: "controls-right" }, Io = /* @__PURE__ */ Ye({
  __name: "StreamAttendeeControlBar",
  props: {
    containerStyle: {},
    barBackgroundColor: { default: "#1e2939" },
    buttonStyle: {},
    buttonHoverStyle: {},
    buttonActiveStyle: {},
    iconStyle: {},
    iconColor: { default: "#ffffff" },
    volumeSliderStyle: {},
    volumeThumbStyle: {},
    volumeTrackStyle: {},
    volumeControlStyle: {},
    padding: {},
    borderRadius: { default: "0" },
    gap: { default: "0px" },
    boxShadow: {},
    backdropFilter: { default: "none" },
    fontFamily: {},
    autoPlay: { type: Boolean, default: !0 },
    autoMute: { type: Boolean, default: !1 }
  },
  setup(W, { expose: y }) {
    gt((oe) => ({
      "856235fc": h.barBackgroundColor === "none" ? "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)" : h.barBackgroundColor,
      a8dd41ca: h.barBackgroundColor === "none" ? "none" : "blur(10px)",
      "30dc32a8": h.gap,
      "45bbe64e": j.value + "px",
      "28fbfe66": h.barBackgroundColor === "none" ? "rgba(0, 0, 0, 0.5)" : h.barBackgroundColor,
      "011747ec": q.value.background || (h.barBackgroundColor === "none" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.2)"),
      "6e512c7d": q.value.transform || "scale(1.05)",
      f48da108: q.value.borderRadius || "4px",
      e5d06a3c: q.value.border || "none",
      bf7583c8: V.value.background || "",
      "15dd69b5": V.value.transform || "scale(0.95)",
      "1611be08": V.value.borderRadius || "4px",
      ff6e2d3c: V.value.border || "none",
      "1cd2c70c": me.value.height || "4px",
      "1ca8b846": me.value.background || "rgba(255, 255, 255, 0.3)",
      "32c3ad37": me.value.borderRadius || "2px",
      "7711a4dd": pe.value.width || "12px",
      "0a4cf084": pe.value.height || "12px",
      "13ee4626": pe.value.background || "white",
      d6215ec8: pe.value.borderRadius || "50%",
      "26fdc13a": pe.value.boxShadow || "0 0 4px rgba(0, 0, 0, 0.3)"
    }));
    const h = W, e = it("streamControls");
    if (!e)
      throw new Error("StreamAttendeeControlBar must be used within StreamProvider");
    const { isConnected: k } = qt(), {
      isPlaying: D,
      isMuted: m,
      volume: g,
      isFullscreen: E,
      togglePlay: A,
      toggleMute: M,
      setVolume: x,
      toggleFullscreen: N
    } = e, S = w(null), X = w(null);
    ut(() => {
      if (h.autoMute && x(0), h.autoPlay && A(), S.value) {
        const oe = S.value.parentElement;
        oe && (X.value = oe);
      }
    });
    const { baseFontSize: Q } = St(X, {
      baseSize: 14,
      // Smaller base size for attendee controls
      referenceWidth: 800,
      minSize: 12,
      maxSize: 18,
      debounceTime: 100
    }), s = n(() => {
      const xe = 16 + 8 * (Q.value - 12) / 6;
      return Math.max(16, Math.min(24, xe));
    }), j = n(() => s.value * 1.8), O = () => {
      A();
    }, P = () => {
      m.value ? x(0.5) : x(0);
    }, $ = (oe) => {
      const se = oe.target, xe = parseInt(se.value) / 100;
      x(xe);
    }, B = () => I(this, null, function* () {
      yield N();
    }), ge = n(() => a({
      padding: h.padding,
      borderRadius: h.borderRadius,
      boxShadow: h.boxShadow,
      backdropFilter: h.backdropFilter,
      fontFamily: h.fontFamily
    }, h.containerStyle)), K = n(() => a({}, h.buttonStyle)), q = n(() => a({}, h.buttonHoverStyle)), V = n(() => a({}, h.buttonActiveStyle)), J = n(() => a({
      gap: h.gap
    }, h.volumeControlStyle)), ke = n(() => a({}, h.volumeSliderStyle)), pe = n(() => a({}, h.volumeThumbStyle)), me = n(() => a({}, h.volumeTrackStyle));
    return y({
      // State
      isPlaying: D,
      isMuted: m,
      volume: g,
      isFullscreen: E,
      isConnected: k,
      // Methods
      togglePlay: A,
      toggleMute: M,
      setVolume: x,
      toggleFullscreen: N
    }), (oe, se) => (l(), p("div", {
      ref_key: "controlBarRef",
      ref: S,
      class: "attendee-control-bar",
      style: f(ge.value)
    }, [
      o("div", To, [
        o("div", _o, [
          o("button", {
            class: "control-button",
            style: f(K.value),
            onClick: O
          }, [
            r(D) ? (l(), ye(Qt, {
              key: 1,
              size: s.value,
              color: h.iconColor
            }, null, 8, ["size", "color"])) : (l(), ye(Jt, {
              key: 0,
              size: s.value,
              color: h.iconColor
            }, null, 8, ["size", "color"]))
          ], 4),
          o("div", {
            class: "volume-control",
            style: f(J.value)
          }, [
            o("button", {
              class: "control-button",
              style: f(K.value),
              onClick: P
            }, [
              !r(m) && r(g) > 0 ? (l(), ye(Ka, {
                key: 0,
                size: s.value,
                color: h.iconColor
              }, null, 8, ["size", "color"])) : (l(), ye(Ja, {
                key: 1,
                size: s.value,
                color: h.iconColor
              }, null, 8, ["size", "color"]))
            ], 4),
            o("input", {
              type: "range",
              class: "volume-slider",
              style: f(ke.value),
              min: "0",
              max: "100",
              value: r(g) * 100,
              onInput: $
            }, null, 44, Eo)
          ], 4)
        ]),
        o("div", zo, [
          o("button", {
            class: "control-button",
            style: f(K.value),
            onClick: B
          }, [
            Y(Qa, {
              variant: r(E) ? "off" : "on",
              size: s.value,
              color: h.iconColor
            }, null, 8, ["variant", "size", "color"])
          ], 4)
        ])
      ])
    ], 4));
  }
}), Wo = /* @__PURE__ */ Ge(Io, [["__scopeId", "data-v-c373cbf1"]]);
export {
  jo as S,
  Oo as a,
  Uo as b,
  Vo as c,
  Wo as d,
  Ho as e
};
